(() => {
  window.WoodarqPdpHero = window.WoodarqPdpHero || {};

  if (window.WoodarqPdpHero.__booted) {
    if (typeof window.WoodarqPdpHero.initAll === 'function') {
      window.WoodarqPdpHero.initAll(document);
    }
    return;
  }

  window.WoodarqPdpHero.__booted = true;


  const ensureDawnProductGalleryCompatibility = () => {
    if (!window.customElements) return;

    if (typeof window.pauseAllMedia !== 'function') {
      window.pauseAllMedia = () => {
        document.querySelectorAll('video, audio').forEach(media => {
          try { media.pause(); } catch (error) {}
        });
      };
    }

    const debounce = (fn, wait = 100) => {
      let timeout;
      return (...args) => {
        window.clearTimeout(timeout);
        timeout = window.setTimeout(() => fn.apply(null, args), wait);
      };
    };

    if (!customElements.get('slider-component')) {
      customElements.define('slider-component', class SliderComponent extends HTMLElement {
        constructor() {
          super();
          this.slider = null;
          this.sliderItems = [];
          this.currentPage = 1;
          this.totalPages = 1;
        }

        connectedCallback() {
          this.slider = this.querySelector('[id^="Slider-"], .slider');
          if (!this.slider) return;
          this.sliderItems = Array.from(this.slider.querySelectorAll('.slider__slide, [data-media-id], [data-target]'));
          this.pageDots = this.querySelector('.slider-counter--current');
          this.pageTotal = this.querySelector('.slider-counter--total');
          this.prevButton = this.querySelector('button[name="previous"], .slider-button--prev');
          this.nextButton = this.querySelector('button[name="next"], .slider-button--next');
          this.resetPages();
          this.slider.addEventListener('scroll', debounce(() => this.update(), 80), { passive: true });
          this.prevButton?.addEventListener('click', event => {
            if (event.defaultPrevented) return;
            this.slideTo(this.currentPage - 2);
          });
          this.nextButton?.addEventListener('click', event => {
            if (event.defaultPrevented) return;
            this.slideTo(this.currentPage);
          });
        }

        resetPages() {
          if (!this.slider) return;
          this.sliderItems = Array.from(this.slider.querySelectorAll('.slider__slide, [data-media-id], [data-target]'));
          this.totalPages = Math.max(1, this.sliderItems.length);
          if (this.pageTotal) this.pageTotal.textContent = String(this.totalPages);
          this.update();
        }

        update() {
          if (!this.slider || !this.sliderItems.length) return;
          const center = this.slider.scrollLeft + (this.slider.clientWidth / 2);
          let closestIndex = 0;
          let closestDistance = Infinity;
          this.sliderItems.forEach((item, index) => {
            const itemCenter = item.offsetLeft + (item.clientWidth / 2);
            const distance = Math.abs(itemCenter - center);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          const previous = this.currentPage;
          this.currentPage = closestIndex + 1;
          if (this.pageDots) this.pageDots.textContent = String(this.currentPage);
          if (previous !== this.currentPage) {
            this.dispatchEvent(new CustomEvent('slideChanged', {
              bubbles: true,
              detail: { currentPage: this.currentPage, currentElement: this.sliderItems[closestIndex] }
            }));
          }
        }

        slideTo(index) {
          if (!this.slider || !this.sliderItems.length) return;
          const safeIndex = Math.max(0, Math.min(index, this.sliderItems.length - 1));
          const item = this.sliderItems[safeIndex];
          if (!item) return;
          this.slider.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
        }

        isSlideVisible(element, offset = 0) {
          if (!this.slider || !element || typeof element.getBoundingClientRect !== 'function') return true;
          const sliderRect = this.slider.getBoundingClientRect();
          const elementRect = element.getBoundingClientRect();
          return elementRect.left >= sliderRect.left - offset && elementRect.right <= sliderRect.right + offset;
        }
      });
    }

    if (!customElements.get('media-gallery')) {
      customElements.define('media-gallery', class MediaGallery extends HTMLElement {
        constructor() {
          super();
          this.elements = {};
        }

        connectedCallback() {
          this.elements = {
            liveRegion: this.querySelector('[id^="GalleryStatus"]'),
            viewer: this.querySelector('[id^="GalleryViewer"]'),
            thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
          };

          this.elements.viewer?.addEventListener('slideChanged', debounce(event => {
            const currentMediaId = event.detail?.currentElement?.dataset?.mediaId;
            if (!currentMediaId || !this.elements.thumbnails) return;
            this.setActiveThumbnail(this.elements.thumbnails.querySelector(`[data-target="${currentMediaId}"]`));
          }, 250));

          this.elements.thumbnails?.querySelectorAll('[data-target]').forEach(mediaToSwitch => {
            mediaToSwitch.querySelector('button')?.addEventListener('click', () => {
              this.setActiveMedia(mediaToSwitch.dataset.target, false);
            });
          });
        }

        setActiveMedia(mediaId, prepend = false) {
          if (!mediaId || !this.elements.viewer) return;
          const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
          if (!activeMedia) return;

          this.elements.viewer.querySelectorAll('[data-media-id]').forEach(element => {
            const isActive = element === activeMedia;
            element.classList.toggle('is-active', isActive);
            element.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          });

          const isWoodarqPdpHeroGallery = this.hasAttribute('data-woodarq-variant-wizard-gallery') || Boolean(this.closest?.('[data-woodarq-pdp-hero]'));
          const shouldPrepend = Boolean(prepend && !isWoodarqPdpHeroGallery);

          if (shouldPrepend && activeMedia.parentElement) {
            activeMedia.parentElement.prepend(activeMedia);
            const activeThumbnail = this.elements.thumbnails?.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail?.parentElement) activeThumbnail.parentElement.prepend(activeThumbnail);
            this.elements.viewer.resetPages?.();
            this.elements.thumbnails?.resetPages?.();
          }

          window.setTimeout(() => {
            const viewerSlider = this.elements.viewer?.slider || this.elements.viewer?.querySelector?.('[id^="Slider-"], .slider');
            if (viewerSlider) viewerSlider.scrollTo({ left: activeMedia.offsetLeft, behavior: 'auto' });
          });

          const activeThumbnail = this.elements.thumbnails?.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(activeThumbnail);
          this.playActiveMedia(activeMedia);
          this.announceLiveRegion(activeMedia, activeThumbnail?.dataset?.mediaPosition);
        }

        setActiveThumbnail(thumbnail) {
          if (!this.elements.thumbnails || !thumbnail) return;
          this.elements.thumbnails.querySelectorAll('button').forEach(button => button.removeAttribute('aria-current'));
          thumbnail.querySelector('button')?.setAttribute('aria-current', 'true');
          const thumbSlider = this.elements.thumbnails.slider || this.elements.thumbnails.querySelector?.('[id^="Slider-"], .slider');
          if (thumbSlider && typeof thumbnail.offsetLeft === 'number') {
            thumbSlider.scrollTo({ left: Math.max(0, thumbnail.offsetLeft - 16), behavior: 'auto' });
          }
        }

        announceLiveRegion(activeItem, position) {
          if (!this.elements.liveRegion || !position) return;
          const image = activeItem?.querySelector?.('.product__modal-opener--image img, img');
          if (!image) return;
          const template = window.accessibilityStrings?.imageAvailable || 'Image [index] is now available in gallery view';
          this.elements.liveRegion.setAttribute('aria-hidden', 'false');
          this.elements.liveRegion.textContent = template.replace('[index]', position);
          window.setTimeout(() => this.elements.liveRegion?.setAttribute('aria-hidden', 'true'), 2000);
        }

        playActiveMedia(activeItem) {
          window.pauseAllMedia?.();
          activeItem?.querySelector?.('.deferred-media')?.loadContent?.(false);
        }
      });
    }
  };

  ensureDawnProductGalleryCompatibility();

  const ROOT_SELECTOR = '[data-woodarq-pdp-hero]';

  const formatMoney = (cents, moneyFormat) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    const amount = (Number(cents || 0) / 100).toFixed(2);
    if (!moneyFormat) return `$${amount}`;

    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents || 0) / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','));
  };

  const normalize = value => String(value || '').trim();

  const getNumber = (value, fallback) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const mountFixedModalToViewport = (modal, root) => {
    if (!modal || !document.body) return modal;

    if (!modal.__wdPdpOriginalParent) {
      modal.__wdPdpOriginalParent = modal.parentNode;
      modal.__wdPdpOriginalNextSibling = modal.nextSibling;
    }

    modal.__wdPdpRoot = root || modal.__wdPdpRoot || null;
    modal.setAttribute('data-wd-pdp-viewport-modal', 'true');

    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    return modal;
  };

  const isIOSLikeDevice = () => {
    const platform = navigator.platform || '';
    const userAgent = navigator.userAgent || '';

    return /iPad|iPhone|iPod/.test(userAgent) || (platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  };

  const isMobilePdpViewport = () => {
    const isSmallViewport = window.matchMedia && window.matchMedia('(max-width: 989px)').matches;
    const isCoarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    return Boolean(isSmallViewport && (isCoarsePointer || navigator.maxTouchPoints > 0 || isIOSLikeDevice()));
  };

  const shouldUseIOSModalGuard = () => isIOSLikeDevice() && window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  const shouldUseMobileModalGuard = () => isMobilePdpViewport();

  const getPageScrollTop = () => {
    const bodyScroll = document.body ? document.body.scrollTop || 0 : 0;
    const docScroll = document.documentElement ? document.documentElement.scrollTop || 0 : 0;
    return Math.max(window.pageYOffset || 0, docScroll, bodyScroll);
  };

  const clampPageScrollTop = scrollTop => {
    const requestedTop = Math.max(0, Number(scrollTop) || 0);
    const scrollingElement = document.scrollingElement || document.documentElement || document.body;
    const body = document.body;
    const doc = document.documentElement;

    const maxFor = el => {
      if (!el) return 0;
      return Math.max(0, (el.scrollHeight || 0) - (el.clientHeight || window.innerHeight || 0));
    };

    const bodyMax = maxFor(body);
    const docMax = maxFor(doc);
    const rootMax = maxFor(scrollingElement);
    const maxScroll = Math.max(bodyMax, docMax, rootMax);
    const safeTop = maxScroll > 0 ? Math.min(requestedTop, maxScroll) : requestedTop;

    if (body && bodyMax > 0) body.scrollTop = Math.min(safeTop, bodyMax);
    if (doc && docMax > 0) doc.scrollTop = Math.min(safeTop, docMax);
    if (scrollingElement && rootMax > 0) scrollingElement.scrollTop = Math.min(safeTop, rootMax);

    try { window.scrollTo(window.pageXOffset || 0, safeTop); } catch (error) {}

    return safeTop;
  };

  const getVisualViewportMetrics = () => {
    const viewport = window.visualViewport || null;
    const doc = document.documentElement;
    const width = viewport?.width || window.innerWidth || doc.clientWidth || 0;
    const height = viewport?.height || window.innerHeight || doc.clientHeight || 0;

    return {
      width: Math.max(0, width),
      height: Math.max(0, height),
      top: Math.max(0, viewport?.offsetTop || 0),
      left: Math.max(0, viewport?.offsetLeft || 0),
      scale: viewport?.scale || 1
    };
  };

  const isPdpV2MobilePage = () => {
    const hasPdpHero = Boolean(document.querySelector(ROOT_SELECTOR));
    const hasPdpTemplate = document.body?.classList.contains('template-product-pdp-v2') || document.body?.classList.contains('is-pdp-v2-active');
    const isMobile = window.matchMedia ? window.matchMedia('(max-width: 989px)').matches : (window.innerWidth || 0) <= 989;
    return Boolean(isMobile && hasPdpHero && hasPdpTemplate);
  };

  const getStableMobileViewportHeight = reset => {
    const doc = document.documentElement;
    const metrics = getVisualViewportMetrics();
    const candidate = Math.round(Math.max(
      window.innerHeight || 0,
      doc?.clientHeight || 0,
      metrics.height || 0
    ));

    if (!window.__woodarqPdpStableViewportHeight || reset) {
      window.__woodarqPdpStableViewportHeight = candidate;
      return candidate;
    }

    const previous = Number(window.__woodarqPdpStableViewportHeight) || candidate;
    const activeElement = document.activeElement;
    const calculatorInputFocused = Boolean(activeElement && activeElement.closest && activeElement.closest('[data-calculator-modal]'));
    const keyboardLikelyOpen = calculatorInputFocused || (metrics.height > 0 && previous > 0 && metrics.height < previous - 90);

    if (!keyboardLikelyOpen && candidate > previous + 12) {
      window.__woodarqPdpStableViewportHeight = candidate;
      return candidate;
    }

    return previous;
  };

  const forceMobilePdpNativeScrollState = reason => {
    if (!isPdpV2MobilePage()) return;

    const stableHeight = getStableMobileViewportHeight(/orientation|pageshow|ready|load/.test(String(reason || '')));

    if (stableHeight > 0) {
      document.documentElement.style.setProperty('--vh', `${stableHeight}px`);
      document.documentElement.style.setProperty('--wd-pdp-stable-viewport-height', `${stableHeight}px`);
    }

    document.documentElement.classList.add('wd-pdp-mobile-native-scroll');
    document.body?.classList.add('wd-pdp-mobile-native-scroll');

    // The original smooth scroll system fixes/translates [data-taxi-view] on desktop.
    // On mobile, keyboard resize events can leave those measurements stale, which
    // shows up as the beige bottom gap while fixed menus still look normal.
    document.body?.classList.remove('is-smooth');

    const selectors = [
      '[data-taxi-view]',
      'main[data-taxi]',
      '.app'
    ];

    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        if (!el || !el.style) return;
        el.style.removeProperty('height');
        el.style.removeProperty('min-height');
        el.style.removeProperty('max-height');
        el.style.removeProperty('transform');
        el.style.removeProperty('translate');
        el.style.removeProperty('position');
        el.style.removeProperty('top');
        el.style.removeProperty('left');
        el.style.removeProperty('right');
        el.style.removeProperty('bottom');
      });
    });

    document.querySelectorAll('[data-woodarq-pdp-hero] .wd-pdp__gallery-col, .woodarq-product-tabs__spec-media').forEach(el => {
      if (!el || !el.style) return;
      el.style.removeProperty('--wd-pdp-hero-sticky-offset');
      el.style.removeProperty('--wpt-spec-sticky-offset');
      el.style.removeProperty('transform');
    });
  };

  const getElementDocumentTop = element => {
    if (!element || typeof element.getBoundingClientRect !== 'function') return getPageScrollTop();
    return element.getBoundingClientRect().top + getPageScrollTop();
  };

  const getMobileHeaderOffset = () => {
    const header = document.querySelector('.main-header');
    const pencil = document.querySelector('.woodarq-pencil-bar, [data-woodarq-pencil-bar]');
    const headerHeight = header && typeof header.getBoundingClientRect === 'function' ? Math.max(0, header.getBoundingClientRect().height || 0) : 0;
    const pencilHeight = pencil && typeof pencil.getBoundingClientRect === 'function' ? Math.max(0, pencil.getBoundingClientRect().height || 0) : 0;
    return Math.min(150, Math.max(72, headerHeight + pencilHeight + 18));
  };

  const scrollWindowToTop = (top, behavior) => {
    const safeTop = Math.max(0, Number(top) || 0);

    try {
      window.scrollTo({
        top: safeTop,
        left: window.pageXOffset || 0,
        behavior: behavior || 'auto'
      });
      return safeTop;
    } catch (error) {
      return clampPageScrollTop(safeTop);
    }
  };

  const scrollElementIntoStableView = (target, fallbackTop, reason, options = {}) => {
    const targetTop = target ? getElementDocumentTop(target) - getMobileHeaderOffset() : fallbackTop;
    const safeTop = Math.max(0, Number.isFinite(targetTop) ? targetTop : Number(fallbackTop) || 0);
    const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const useSmoothScroll = Boolean(options.smooth && !prefersReducedMotion);
    const firstDelay = Math.max(0, Number(options.initialDelay) || 0);

    const steps = useSmoothScroll
      ? [
          { delay: firstDelay, behavior: 'smooth', threshold: 4 },
          { delay: firstDelay + 440, behavior: 'auto', threshold: 42 },
          { delay: firstDelay + 760, behavior: 'auto', threshold: 80 }
        ]
      : [
          { delay: firstDelay, behavior: 'auto', threshold: 4 },
          { delay: firstDelay + 180, behavior: 'auto', threshold: 36 }
        ];

    steps.forEach(step => {
      window.setTimeout(() => {
        normalizeMobilePdpViewportState(reason || 'scroll-target');
        const currentTop = getPageScrollTop();

        if (Math.abs(currentTop - safeTop) <= step.threshold) return;

        if (step.behavior === 'smooth') {
          scrollWindowToTop(safeTop, 'smooth');
        } else {
          clampPageScrollTop(safeTop);
        }
      }, step.delay);
    });
  };

  const normalizeMobilePdpViewportState = reason => {
    if (!shouldUseMobileModalGuard()) return;
    forceMobilePdpNativeScrollState(reason || 'normalize');
  };

  const lockMobilePdpPage = scrollTop => {
    if (!shouldUseMobileModalGuard() || !document.body) return;

    const safeTop = Math.max(0, Number(scrollTop) || getPageScrollTop());
    forceMobilePdpNativeScrollState('calculator-lock');

    document.documentElement.classList.add('wd-pdp-calculator-page-locked');
    document.body.classList.add('wd-pdp-calculator-page-locked');
    document.body.dataset.wdPdpLockedScrollTop = String(safeTop);

    // Do not use body{position:fixed} here. On iOS and Android, closing the
    // numeric keyboard after a fixed-body lock is the root cause of the
    // persistent beige bottom gap. The fixed calculator modal already prevents
    // background interaction; the page itself must stay in normal flow.
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('left');
    document.body.style.removeProperty('right');
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('height');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('touch-action');
  };

  const unlockMobilePdpPage = scrollTop => {
    if (!document.body) return;

    const savedFromDataset = Number(document.body.dataset.wdPdpLockedScrollTop);
    const safeTop = Math.max(0, Number(scrollTop) || (Number.isFinite(savedFromDataset) ? savedFromDataset : 0));

    document.documentElement.classList.remove('wd-pdp-calculator-page-locked');
    document.body.classList.remove('wd-pdp-calculator-page-locked');
    delete document.body.dataset.wdPdpLockedScrollTop;

    ['position', 'top', 'left', 'right', 'width', 'height', 'overflow', 'overflow-y', 'touch-action'].forEach(property => {
      document.body.style.removeProperty(property);
      document.documentElement.style.removeProperty(property);
    });

    forceMobilePdpNativeScrollState('calculator-unlock');
    clampPageScrollTop(safeTop);
  };

  const isIOSKeyboardLikelyOpen = () => {
    if (!shouldUseIOSModalGuard() || !window.visualViewport) return false;

    const metrics = getVisualViewportMetrics();
    const layoutHeight = window.innerHeight || document.documentElement.clientHeight || metrics.height;

    return metrics.height > 0 && layoutHeight > 0 && metrics.height < layoutHeight - 90;
  };

  const syncVisualViewportHeight = () => {
    const metrics = getVisualViewportMetrics();
    const rootStyle = document.documentElement.style;

    if (metrics.height > 0) {
      rootStyle.setProperty('--wd-pdp-visual-viewport-height', `${Math.round(metrics.height)}px`);
    }

    if (metrics.width > 0) {
      rootStyle.setProperty('--wd-pdp-visual-viewport-width', `${Math.round(metrics.width)}px`);
    }

    rootStyle.setProperty('--wd-pdp-visual-viewport-top', `${Math.round(metrics.top)}px`);
    rootStyle.setProperty('--wd-pdp-visual-viewport-left', `${Math.round(metrics.left)}px`);
    rootStyle.setProperty('--wd-pdp-visual-viewport-scale', `${metrics.scale}`);

    const keyboardOpen = isIOSKeyboardLikelyOpen();
    document.documentElement.classList.toggle('wd-pdp-keyboard-open', keyboardOpen);
    document.body?.classList.toggle('wd-pdp-keyboard-open', keyboardOpen);
  };

  const requestPdpLayoutRefresh = reason => {
    const refreshReason = reason || 'pdp-modal-change';

    try {
      if (window.WoodarqPdpV2Stability) {
        if (typeof window.WoodarqPdpV2Stability.refreshMeasurements === 'function') {
          window.WoodarqPdpV2Stability.refreshMeasurements(refreshReason);
        }

        if (typeof window.WoodarqPdpV2Stability.refresh === 'function') {
          window.WoodarqPdpV2Stability.refresh(refreshReason);
        }
      }
    } catch (error) {}

    try {
      document.dispatchEvent(new CustomEvent('woodarq:pdp-v2:viewport-refresh', {
        detail: { reason: refreshReason }
      }));
    } catch (error) {}
  };

  const hasOpenPdpViewportModal = () => {
    return Array.from(document.querySelectorAll('[data-calculator-modal], [data-delivery-zip-modal], [data-service-drawer]')).some(modal => {
      if (!modal || modal.hidden || modal.getAttribute('aria-hidden') === 'true') return false;
      if (window.getComputedStyle) {
        const styles = window.getComputedStyle(modal);
        if (styles.display === 'none' || styles.visibility === 'hidden') return false;
      }
      return true;
    });
  };

  const cleanupPdpModalLockState = force => {
    if (!force && hasOpenPdpViewportModal()) return;

    document.documentElement.classList.remove('wd-pdp-modal-open', 'wd-pdp-keyboard-open', 'wd-pdp-calculator-page-locked');
    document.body?.classList.remove('wd-pdp-modal-open', 'wd-pdp-calculator-modal-open', 'wd-pdp-keyboard-open', 'wd-pdp-calculator-page-locked');
    if (document.body?.dataset) delete document.body.dataset.wdPdpLockedScrollTop;

    [document.documentElement, document.body].forEach(el => {
      if (!el || !el.style) return;
      el.style.removeProperty('overflow');
      el.style.removeProperty('overflow-y');
      el.style.removeProperty('position');
      el.style.removeProperty('top');
      el.style.removeProperty('left');
      el.style.removeProperty('right');
      el.style.removeProperty('width');
      el.style.removeProperty('height');
      el.style.removeProperty('touch-action');
    });

    forceMobilePdpNativeScrollState('cleanup-modal-lock');
  };

  const repairViewportAfterCalculatorClose = (savedScrollTop, reason, scrollTarget) => {
    const restoreTop = Math.max(0, Number(savedScrollTop) || getPageScrollTop());
    const hasTargetScroll = Boolean(scrollTarget);
    const delays = shouldUseMobileModalGuard()
      ? (hasTargetScroll ? [0, 70, 180, 360, 700, 1100] : [0, 60, 140, 280, 520, 900, 1300])
      : [0, 120, 320];

    delays.forEach(delay => {
      window.setTimeout(() => {
        forceMobilePdpNativeScrollState(`${reason || 'calculator-close'}-${delay}`);
        syncVisualViewportHeight();
        cleanupPdpModalLockState(false);
        normalizeMobilePdpViewportState(`${reason || 'calculator-close'}-${delay}`);

        // When Apply Quantity closes the calculator, the page intentionally scrolls
        // to the purchase area. Do not keep forcing the old pre-modal scrollTop
        // after that target scroll begins, because that creates the small visible
        // snap/click even though the bottom gap has been fixed.
        if (!hasTargetScroll || delay <= 90) {
          clampPageScrollTop(restoreTop);
        }

        requestPdpLayoutRefresh(`${reason || 'calculator-close'}-${delay}`);
      }, delay);
    });

    if (scrollTarget) {
      window.setTimeout(() => {
        scrollElementIntoStableView(scrollTarget, restoreTop, reason || 'calculator-apply', {
          smooth: shouldUseMobileModalGuard(),
          initialDelay: shouldUseMobileModalGuard() ? 40 : 0
        });
      }, shouldUseMobileModalGuard() ? 170 : 60);
    }
  };

  const repairIOSCalculatorFocusScroll = (modal, savedScrollTop, reason) => {
    if (!shouldUseMobileModalGuard() || !modal || modal.hidden) return;

    const restoreTop = Math.max(0, Number(savedScrollTop) || getPageScrollTop());
    [0, 45, 110, 220].forEach(delay => {
      window.setTimeout(() => {
        if (!modal || modal.hidden) return;
        forceMobilePdpNativeScrollState(`${reason || 'calculator-focus'}-${delay}`);
        syncVisualViewportHeight();
        clampPageScrollTop(restoreTop);
        requestPdpLayoutRefresh(`${reason || 'calculator-focus'}-${delay}`);
      }, delay);
    });
  };

  const lockCalculatorModal = savedScrollTop => {
    syncVisualViewportHeight();
    normalizeMobilePdpViewportState('calculator-open');
    document.body?.classList.add('wd-pdp-calculator-modal-open');

    if (shouldUseMobileModalGuard()) {
      lockMobilePdpPage(savedScrollTop);
      document.documentElement.classList.remove('wd-pdp-modal-open');
      document.body?.classList.remove('wd-pdp-modal-open');
      return;
    }

    document.documentElement.classList.add('wd-pdp-modal-open');
    document.body?.classList.add('wd-pdp-modal-open');
  };

  const unlockCalculatorModal = (savedScrollTop, reason, scrollTarget) => {
    if (shouldUseMobileModalGuard()) {
      unlockMobilePdpPage(savedScrollTop);
    }

    cleanupPdpModalLockState(false);
    repairViewportAfterCalculatorClose(savedScrollTop, reason || 'calculator-close', scrollTarget);
  };

  if (!window.__woodarqPdpVisualViewportHeightBound && window.visualViewport) {
    window.__woodarqPdpVisualViewportHeightBound = true;
    syncVisualViewportHeight();
    window.visualViewport.addEventListener('resize', syncVisualViewportHeight, { passive: true });
    window.visualViewport.addEventListener('scroll', syncVisualViewportHeight, { passive: true });
  } else {
    syncVisualViewportHeight();
  }

  forceMobilePdpNativeScrollState('boot');
  ['load', 'pageshow', 'resize', 'orientationchange', 'focus', 'blur'].forEach(eventName => {
    window.addEventListener(eventName, () => {
      const delays = eventName === 'resize' ? [0, 90, 260, 520] : [0];
      delays.forEach(delay => {
        window.setTimeout(() => forceMobilePdpNativeScrollState(eventName), delay);
      });
    }, { passive: true });
  });

  const addBusinessDays = (startDate, days) => {
    const date = new Date(startDate.getTime());
    let added = 0;

    while (added < days) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }

    return date;
  };

  const getOrderCutoffText = cutoffHour => {
    const now = new Date();
    const cutoff = new Date(now.getTime());
    cutoff.setHours(cutoffHour, 0, 0, 0);

    if (now > cutoff) cutoff.setDate(cutoff.getDate() + 1);

    const diff = Math.max(0, cutoff.getTime() - now.getTime());
    const totalMinutes = Math.floor(diff / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours <= 0) return `${minutes} mins`;
    return `${hours} hrs ${minutes} mins`;
  };

  const findVariantByOptions = (variants, selectedOptions) => {
    return variants.find(variant => {
      return variant.options.every((option, index) => normalize(option) === normalize(selectedOptions[index]));
    });
  };

  const isPdpHeroFineHoverPointer = () => {
    return Boolean(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  };

  const setPdpImageZoomOrigin = (target, event) => {
    if (!target || !event || typeof target.getBoundingClientRect !== 'function') return;

    const rect = target.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    const x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
    const y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));

    target.style.setProperty('--wd-pdp-zoom-origin-x', `${x.toFixed(2)}%`);
    target.style.setProperty('--wd-pdp-zoom-origin-y', `${y.toFixed(2)}%`);
  };

  const initGallery = root => {
    const slides = Array.from(root.querySelectorAll('[data-slide-index]'));
    const dots = Array.from(root.querySelectorAll('[data-dot-index]'));
    const slidesContainer = root.querySelector('[data-slides]');
    const dotsContainer = root.querySelector('[data-gallery-dots]');
    const prev = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');
    let activeIndex = slides.findIndex(slide => slide.classList.contains('is-active'));
    let suppressNextClick = false;
    let dotsResizeTimer = null;
    if (activeIndex < 0) activeIndex = 0;

    const clamp = (value, min, max) => Math.max(min, Math.min(value, max));

    const canScrollDots = () => {
      if (!dotsContainer) return false;
      return dotsContainer.scrollWidth > dotsContainer.clientWidth + 2;
    };

    const centerActiveDot = (index, behavior = 'smooth') => {
      const dot = dots[index];
      if (!dot || !dotsContainer || !canScrollDots()) return;

      const target = dot.offsetLeft - (dotsContainer.clientWidth / 2) + (dot.offsetWidth / 2);
      const maxScroll = Math.max(0, dotsContainer.scrollWidth - dotsContainer.clientWidth);

      dotsContainer.scrollTo({
        left: clamp(target, 0, maxScroll),
        behavior
      });
    };

    const updateDotCarousel = (index, behavior = 'smooth') => {
      if (!dotsContainer || !dots.length) return;

      const isOverflowing = canScrollDots();
      dotsContainer.classList.toggle('wd-pdp__dots--carousel', isOverflowing);

      dots.forEach((dot, idx) => {
        const distance = Math.abs(idx - index);
        dot.classList.toggle('is-dot-edge', isOverflowing && distance >= 5 && distance <= 6);
        dot.classList.toggle('is-dot-far', isOverflowing && distance > 6);
      });

      if (isOverflowing) {
        centerActiveDot(index, behavior);
      } else {
        dotsContainer.scrollTo({ left: 0, behavior: 'auto' });
      }
    };

    const queueDotRefresh = (behavior = 'auto') => {
      window.clearTimeout(dotsResizeTimer);
      dotsResizeTimer = window.setTimeout(() => updateDotCarousel(activeIndex, behavior), 40);
    };

    const isElementAppHidden = element => {
      if (!element) return true;
      if (element.hidden) return true;

      if (element.matches && element.matches('[data-variant-wizard-hidden="true"], [data-productwiz-hidden="true"], [data-pw-hidden="true"], .variant-wizard-hidden, .productwiz-hidden, .pw-hidden')) {
        return true;
      }

      const style = window.getComputedStyle ? window.getComputedStyle(element) : null;
      return Boolean(style && (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0 && element.classList.contains('productwiz-hidden')));
    };

    const getVisibleSlideIndexes = () => {
      const indexes = slides
        .map((slide, idx) => (isElementAppHidden(slide) ? -1 : idx))
        .filter(idx => idx >= 0);

      return indexes.length ? indexes : slides.map((_, idx) => idx);
    };

    const resolveVisibleIndex = (index, direction = 1) => {
      const visibleIndexes = getVisibleSlideIndexes();
      if (!visibleIndexes.length) return 0;
      if (visibleIndexes.includes(index)) return index;

      const ordered = direction < 0 ? [...visibleIndexes].reverse() : visibleIndexes;
      const match = ordered.find(idx => (direction < 0 ? idx < index : idx > index));
      return typeof match === 'number' ? match : ordered[0];
    };

    const show = (index, behavior = 'smooth') => {
      if (!slides.length) return;

      const rawIndex = (index + slides.length) % slides.length;
      const direction = rawIndex < activeIndex ? -1 : 1;
      const safeIndex = resolveVisibleIndex(rawIndex, direction);

      slides.forEach((slide, idx) => {
        const isActive = idx === safeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      dots.forEach((dot, idx) => {
        const isActive = idx === safeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');

        const thumbnailButton = dot.matches('button') ? dot : dot.querySelector('button');
        if (thumbnailButton) thumbnailButton.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      activeIndex = safeIndex;
      updateDotCarousel(safeIndex, behavior);
    };

    dots.forEach(dot => {
      dot.addEventListener('click', () => show(Number(dot.dataset.dotIndex || 0)));
    });

    const showAdjacentVisible = direction => {
      const visibleIndexes = getVisibleSlideIndexes();
      if (!visibleIndexes.length) return show(activeIndex + direction);

      const currentVisiblePosition = visibleIndexes.indexOf(activeIndex);
      const fallbackPosition = direction > 0 ? 0 : visibleIndexes.length - 1;
      const currentPosition = currentVisiblePosition >= 0 ? currentVisiblePosition : fallbackPosition;
      const nextPosition = (currentPosition + direction + visibleIndexes.length) % visibleIndexes.length;

      show(visibleIndexes[nextPosition]);
    };

    prev?.addEventListener('click', () => showAdjacentVisible(-1));
    next?.addEventListener('click', () => showAdjacentVisible(1));

    slides.forEach(slide => {
      slide.addEventListener('pointerenter', event => {
        if (!slide.classList.contains('is-active') || !isPdpHeroFineHoverPointer()) return;
        slide.classList.add('is-zooming');
        setPdpImageZoomOrigin(slide, event);
      });

      slide.addEventListener('pointermove', event => {
        if (!slide.classList.contains('is-active') || !isPdpHeroFineHoverPointer()) return;
        setPdpImageZoomOrigin(slide, event);
      });

      slide.addEventListener('pointerleave', () => {
        slide.classList.remove('is-zooming');
        slide.style.removeProperty('--wd-pdp-zoom-origin-x');
        slide.style.removeProperty('--wd-pdp-zoom-origin-y');
      });
    });

    if (slidesContainer && slides.length > 1) {
      let pointerId = null;
      let startX = 0;
      let startY = 0;
      let isHorizontalSwipe = false;
      const activePointers = new Set();

      const releasePointer = id => {
        if (id == null || !slidesContainer.hasPointerCapture || !slidesContainer.hasPointerCapture(id)) return;

        try {
          slidesContainer.releasePointerCapture(id);
        } catch (error) {
          // Some embedded webviews can throw here after a native gesture takes over.
        }
      };

      const resetPointer = () => {
        releasePointer(pointerId);
        pointerId = null;
        startX = 0;
        startY = 0;
        isHorizontalSwipe = false;
      };

      const isMultiTouchGesture = () => activePointers.size > 1;

      const onPointerDown = event => {
        activePointers.add(event.pointerId);

        // Leave two-finger gestures alone so the browser can perform native pinch zoom.
        if (isMultiTouchGesture()) {
          resetPointer();
          return;
        }

        if (event.button && event.button !== 0) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        isHorizontalSwipe = false;

        // Pointer capture is useful for mouse dragging, but on touch devices it can
        // interfere with iOS/Android handing a pinch gesture back to the browser.
        if (event.pointerType === 'mouse') {
          try {
            slidesContainer.setPointerCapture(pointerId);
          } catch (error) {
            // Pointer capture is not supported in every embedded webview. The swipe still works without it.
          }
        }
      };

      const onPointerMove = event => {
        if (isMultiTouchGesture()) return;
        if (pointerId !== event.pointerId) return;

        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;

        if (!isHorizontalSwipe && Math.abs(deltaX) > 9 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) {
          isHorizontalSwipe = true;
        }

        if (isHorizontalSwipe) {
          event.preventDefault();
        }
      };

      const onPointerUp = event => {
        activePointers.delete(event.pointerId);

        if (pointerId !== event.pointerId) return;

        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;
        const swipeDistance = Math.max(42, Math.min(86, slidesContainer.clientWidth * 0.12));
        const validSwipe = Math.abs(deltaX) >= swipeDistance && Math.abs(deltaX) > Math.abs(deltaY) * 1.2;

        if (validSwipe) {
          suppressNextClick = true;
          showAdjacentVisible(deltaX < 0 ? 1 : -1);
          window.setTimeout(() => { suppressNextClick = false; }, 120);
        }

        resetPointer();
      };

      const onPointerCancel = event => {
        activePointers.delete(event.pointerId);
        if (pointerId === event.pointerId) resetPointer();
      };

      slidesContainer.addEventListener('pointerdown', onPointerDown);
      slidesContainer.addEventListener('pointermove', onPointerMove);
      slidesContainer.addEventListener('pointerup', onPointerUp);
      slidesContainer.addEventListener('pointercancel', onPointerCancel);
      slidesContainer.addEventListener('click', event => {
        if (!suppressNextClick) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
    }

    show(activeIndex, 'auto');
    window.addEventListener('resize', () => queueDotRefresh('auto'), { passive: true });

    if (window.ResizeObserver && dotsContainer) {
      const observer = new ResizeObserver(() => queueDotRefresh('auto'));
      observer.observe(dotsContainer);
      if (slidesContainer) observer.observe(slidesContainer);
    }

    const refreshAfterAppFiltering = (behavior = 'auto') => {
      const visibleIndexes = getVisibleSlideIndexes();

      if (visibleIndexes.length && !visibleIndexes.includes(activeIndex)) {
        show(visibleIndexes[0], behavior);
        return;
      }

      updateDotCarousel(activeIndex, behavior);
    };

    if (window.MutationObserver) {
      const appMutationObserver = new MutationObserver(() => {
        refreshAfterAppFiltering('auto');
      });

      [...slides, ...dots].forEach(element => {
        appMutationObserver.observe(element, {
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'data-variant-wizard-hidden', 'data-productwiz-hidden', 'data-pw-hidden']
        });
      });
    }

    return {
      show,
      refreshAfterAppFiltering,
      getVisibleSlideIndexes,
      showMedia(mediaId, behavior = 'smooth') {
        if (!mediaId) return;

        const requestedId = String(mediaId);
        const index = slides.findIndex(slide => {
          const mediaIdWithSection = String(slide.dataset.mediaId || '');
          const rawMediaId = String(slide.dataset.wdMediaId || '');
          return mediaIdWithSection === requestedId || rawMediaId === requestedId || mediaIdWithSection.endsWith(`-${requestedId}`);
        });

        if (index >= 0) show(index, behavior);
      }
    };
  };

  const normalizeCalculatorFormulaConfig = (data = {}) => {
    const name = normalize(data.name || data.formula_name || '');
    const feet = normalize(data.feet || data.formula_feet || data.formula || '');
    const meter = normalize(data.meter || data.formula_meter || '');
    const formulaSource = normalize(data.formula_source || data.source || '');
    const hasFormulaMetafield = typeof data.has_formula_metafield === 'boolean'
      ? data.has_formula_metafield
      : (typeof data.hasFormulaMetafield === 'boolean'
        ? data.hasFormulaMetafield
        : Boolean(name || feet || meter));

    return {
      id: data.id || data.variant_id || '',
      variantId: data.variant_id || data.id || '',
      hasFormulaMetafield,
      has_formula_metafield: hasFormulaMetafield,
      name,
      feet,
      meter,
      formula: feet,
      formula_source: formulaSource,
      source: formulaSource
    };
  };

  const readCalculatorJson = (root, selector, fallback) => {
    const defaultValue = typeof fallback === 'undefined' ? {} : fallback;
    const script = root.querySelector(selector);

    if (!script) return defaultValue;

    try {
      return JSON.parse(script.textContent || (Array.isArray(defaultValue) ? '[]' : '{}'));
    } catch (error) {
      console.warn(`Woodarq PDP hero: could not parse ${selector} JSON`, error);
      return defaultValue;
    }
  };

  const readCalculatorFormulaConfig = root => {
    if (root.__wdPdpActiveCalculatorFormulaConfig) {
      return root.__wdPdpActiveCalculatorFormulaConfig;
    }

    const fallback = {
      has_formula_metafield: root.dataset.hasCalculatorFormula === 'true' || Boolean(root.dataset.calculatorFormulaName || root.dataset.calculatorFormulaFeet || root.dataset.calculatorFormulaMeter),
      name: root.dataset.calculatorFormulaName || '',
      feet: root.dataset.calculatorFormulaFeet || '',
      meter: root.dataset.calculatorFormulaMeter || '',
      formula_source: root.dataset.calculatorFormulaSource || ''
    };

    const formulaScript = root.querySelector('[data-calculator-formula-json]');
    if (!formulaScript) {
      return normalizeCalculatorFormulaConfig(fallback);
    }

    try {
      return normalizeCalculatorFormulaConfig(Object.assign({}, fallback, JSON.parse(formulaScript.textContent || '{}')));
    } catch (error) {
      console.warn('Woodarq PDP hero: could not parse calculator formula JSON', error);
      return normalizeCalculatorFormulaConfig(fallback);
    }
  };

  const writeCalculatorFormulaConfig = (root, config) => {
    const normalizedConfig = normalizeCalculatorFormulaConfig(config || {});
    const hasFormula = Boolean(normalizedConfig.hasFormulaMetafield && (normalizedConfig.feet || normalizedConfig.meter));
    const signature = `${normalizedConfig.variantId || normalizedConfig.id || 'product'}::${normalizedConfig.formula_source || normalizedConfig.source || ''}::${normalizedConfig.feet || ''}::${normalizedConfig.meter || ''}`;

    root.__wdPdpActiveCalculatorFormulaConfig = normalizedConfig;
    root.dataset.hasCalculatorFormula = hasFormula ? 'true' : 'false';
    root.dataset.calculatorFormulaName = normalizedConfig.name || '';
    root.dataset.calculatorFormulaFeet = normalizedConfig.feet || '';
    root.dataset.calculatorFormulaMeter = normalizedConfig.meter || '';
    root.dataset.calculatorFormulaSource = normalizedConfig.formula_source || normalizedConfig.source || '';

    const formulaScript = root.querySelector('[data-calculator-formula-json]');
    if (formulaScript) {
      formulaScript.textContent = JSON.stringify({
        has_formula_metafield: hasFormula,
        name: normalizedConfig.name || '',
        feet: normalizedConfig.feet || '',
        meter: normalizedConfig.meter || '',
        formula_source: normalizedConfig.formula_source || normalizedConfig.source || ''
      });
    }

    const calculatorBlock = root.querySelector('[data-calculator-block]');
    const calculatorOpen = root.querySelector('[data-calculator-open]');
    const calculatorModal = getCalculatorModal(root);
    const result = calculatorModal?.querySelector('[data-calc-result]') || root.querySelector('[data-calc-result]');
    const apply = calculatorModal?.querySelector('[data-calc-apply]') || root.querySelector('[data-calc-apply]');

    updateCalculatorUnitUI(root, normalizedConfig);

    if (calculatorBlock) {
      calculatorBlock.hidden = !hasFormula;
      calculatorBlock.setAttribute('aria-hidden', hasFormula ? 'false' : 'true');
    }

    if (calculatorOpen) {
      calculatorOpen.disabled = !hasFormula;
      calculatorOpen.setAttribute('aria-disabled', hasFormula ? 'false' : 'true');
    }

    if (root.__wdPdpCalculatorFormulaSignature && root.__wdPdpCalculatorFormulaSignature !== signature) {
      if (result) result.textContent = '';
      if (apply) apply.hidden = true;
    }

    root.__wdPdpCalculatorFormulaSignature = signature;

    if (!hasFormula && calculatorModal) {
      const savedScrollTop = getPageScrollTop();
      calculatorModal.hidden = true;
      calculatorModal.setAttribute('aria-hidden', 'true');
      cleanupPdpModalLockState(false);
      repairViewportAfterCalculatorClose(savedScrollTop, 'calculator-formula-hidden');
      if (result) result.textContent = '';
      if (apply) apply.hidden = true;
    }

    return normalizedConfig;
  };

  const evaluateCalculatorFormula = (formula, width, height) => {
    const rawFormula = String(formula || '').trim();
    if (!rawFormula) return null;

    const expression = rawFormula
      .replace(/[×x]/g, '*')
      .replace(/[÷]/g, '/')
      .toLowerCase();

    if (!/^[0-9+\-*/().\s_a-z]+$/.test(expression)) return null;

    const values = {
      w: width,
      h: height,
      width,
      height,
      wall_width: width,
      wall_height: height
    };

    const tokens = [];
    let index = 0;
    let previousType = 'start';

    const isDigit = char => /[0-9]/.test(char);
    const isIdentifierStart = char => /[a-z_]/.test(char);
    const isIdentifierPart = char => /[a-z0-9_]/.test(char);
    const isUnaryPosition = () => previousType === 'start' || previousType === 'operator' || previousType === '(';

    while (index < expression.length) {
      const char = expression[index];

      if (/\s/.test(char)) {
        index += 1;
        continue;
      }

      if ((char === '-' || char === '+') && isUnaryPosition()) {
        const next = expression[index + 1];

        if (isDigit(next) || next === '.') {
          let number = char;
          index += 1;
          while (index < expression.length && (isDigit(expression[index]) || expression[index] === '.')) {
            number += expression[index];
            index += 1;
          }

          const parsed = Number(number);
          if (!Number.isFinite(parsed)) return null;
          tokens.push({ type: 'number', value: parsed });
          previousType = 'number';
          continue;
        }

        if (char === '-') {
          tokens.push({ type: 'number', value: 0 });
          tokens.push({ type: 'operator', value: '-' });
          previousType = 'operator';
          index += 1;
          continue;
        }
      }

      if (isDigit(char) || char === '.') {
        let number = '';
        while (index < expression.length && (isDigit(expression[index]) || expression[index] === '.')) {
          number += expression[index];
          index += 1;
        }

        const parsed = Number(number);
        if (!Number.isFinite(parsed)) return null;
        tokens.push({ type: 'number', value: parsed });
        previousType = 'number';
        continue;
      }

      if (isIdentifierStart(char)) {
        let identifier = '';
        while (index < expression.length && isIdentifierPart(expression[index])) {
          identifier += expression[index];
          index += 1;
        }

        if (!Object.prototype.hasOwnProperty.call(values, identifier)) return null;
        const parsed = Number(values[identifier]);
        if (!Number.isFinite(parsed)) return null;
        tokens.push({ type: 'number', value: parsed });
        previousType = 'number';
        continue;
      }

      if ('+-*/'.includes(char)) {
        tokens.push({ type: 'operator', value: char });
        previousType = 'operator';
        index += 1;
        continue;
      }

      if (char === '(' || char === ')') {
        tokens.push({ type: char, value: char });
        previousType = char;
        index += 1;
        continue;
      }

      return null;
    }

    const output = [];
    const operators = [];
    const precedence = { '+': 1, '-': 1, '*': 2, '/': 2 };

    for (const token of tokens) {
      if (token.type === 'number') {
        output.push(token);
        continue;
      }

      if (token.type === 'operator') {
        while (
          operators.length &&
          operators[operators.length - 1].type === 'operator' &&
          precedence[operators[operators.length - 1].value] >= precedence[token.value]
        ) {
          output.push(operators.pop());
        }
        operators.push(token);
        continue;
      }

      if (token.type === '(') {
        operators.push(token);
        continue;
      }

      if (token.type === ')') {
        while (operators.length && operators[operators.length - 1].type !== '(') {
          output.push(operators.pop());
        }
        if (!operators.length) return null;
        operators.pop();
      }
    }

    while (operators.length) {
      const operator = operators.pop();
      if (operator.type === '(' || operator.type === ')') return null;
      output.push(operator);
    }

    const stack = [];

    for (const token of output) {
      if (token.type === 'number') {
        stack.push(token.value);
        continue;
      }

      const right = stack.pop();
      const left = stack.pop();
      if (!Number.isFinite(left) || !Number.isFinite(right)) return null;

      if (token.value === '+') stack.push(left + right);
      if (token.value === '-') stack.push(left - right);
      if (token.value === '*') stack.push(left * right);
      if (token.value === '/') {
        if (right === 0) return null;
        stack.push(left / right);
      }
    }

    const result = stack.length === 1 ? stack[0] : null;
    return Number.isFinite(result) ? result : null;
  };

  const getCalculatorItemLabel = (label, quantity) => {
    const cleanLabel = normalize(label);
    const productName = cleanLabel || 'panel';
    const boxLabel = quantity === 1 ? 'box' : 'boxes';
    return `${boxLabel} of ${productName}`;
  };

  const normalizeCalculatorUnit = unit => {
    const normalizedUnit = normalize(unit).toLowerCase();
    if (normalizedUnit === 'meter' || normalizedUnit === 'meters' || normalizedUnit === 'metre' || normalizedUnit === 'metres' || normalizedUnit === 'm') return 'meter';
    return 'feet';
  };

  const getCalculatorUnitMeta = unit => {
    const normalizedUnit = normalizeCalculatorUnit(unit);
    if (normalizedUnit === 'meter') {
      return {
        unit: 'meter',
        field: 'meter',
        shortLabel: 'm',
        areaLabel: 'm²',
        widthPlaceholder: '3.6',
        heightPlaceholder: '2.4'
      };
    }

    return {
      unit: 'feet',
      field: 'feet',
      shortLabel: 'ft',
      areaLabel: 'ft²',
      widthPlaceholder: '12',
      heightPlaceholder: '8'
    };
  };

  const getAvailableCalculatorUnits = formulaConfig => {
    const config = formulaConfig || {};
    const units = [];
    if (normalize(config?.feet)) units.push('feet');
    if (normalize(config?.meter)) units.push('meter');
    return units;
  };

  const getActiveCalculatorUnit = (root, formulaConfig, preferredUnit) => {
    const config = formulaConfig || (root ? readCalculatorFormulaConfig(root) : {});
    const requestedUnit = normalizeCalculatorUnit(preferredUnit || root?.__wdPdpCalculatorUnit || root?.dataset?.calculatorUnit || 'feet');
    const availableUnits = getAvailableCalculatorUnits(config);

    if (availableUnits.includes(requestedUnit)) return requestedUnit;
    if (availableUnits.includes('feet')) return 'feet';
    if (availableUnits.includes('meter')) return 'meter';
    return 'feet';
  };

  const getCalculatorModal = root => {
    if (!root) return document.querySelector('[data-calculator-modal][data-wd-pdp-viewport-modal="true"], [data-calculator-modal]');

    if (root.__wdPdpCalculatorModal && document.documentElement.contains(root.__wdPdpCalculatorModal)) {
      return root.__wdPdpCalculatorModal;
    }

    const ownerId = root.dataset?.wdPdpCalculatorOwner || '';
    const ownedModal = Array.from(document.querySelectorAll('[data-calculator-modal][data-wd-pdp-viewport-modal="true"]')).find(modal => {
      return modal.__wdPdpRoot === root || (ownerId && modal.dataset.wdPdpOwner === ownerId);
    });

    if (ownedModal) {
      root.__wdPdpCalculatorModal = ownedModal;
      return ownedModal;
    }

    return root.querySelector('[data-calculator-modal]');
  };

  const resetCalculatorResult = root => {
    const modal = getCalculatorModal(root);
    const result = modal?.querySelector('[data-calc-result]') || root.querySelector('[data-calc-result]');
    const apply = modal?.querySelector('[data-calc-apply]') || root.querySelector('[data-calc-apply]');
    if (result) result.textContent = '';
    if (apply) apply.hidden = true;
  };

  const updateCalculatorUnitUI = (root, formulaConfig) => {
    if (!root) return 'feet';

    const config = formulaConfig || readCalculatorFormulaConfig(root);
    const activeUnit = getActiveCalculatorUnit(root, config);
    const unitMeta = getCalculatorUnitMeta(activeUnit);
    const availableUnits = getAvailableCalculatorUnits(config);
    const modal = getCalculatorModal(root);

    root.__wdPdpCalculatorUnit = activeUnit;
    root.dataset.calculatorUnit = activeUnit;

    if (!modal) return activeUnit;

    const unitSwitch = modal.querySelector('[data-calc-unit-switch]') || root.querySelector('[data-calc-unit-switch]');
    const widthUnitLabel = modal.querySelector('[data-calc-width-unit]') || root.querySelector('[data-calc-width-unit]');
    const heightUnitLabel = modal.querySelector('[data-calc-height-unit]') || root.querySelector('[data-calc-height-unit]');
    const widthInput = modal.querySelector('[data-calc-width]') || root.querySelector('[data-calc-width]');
    const heightInput = modal.querySelector('[data-calc-height]') || root.querySelector('[data-calc-height]');
    const unitButtons = Array.from(modal.querySelectorAll('[data-calc-unit]'));

    if (widthUnitLabel) widthUnitLabel.textContent = `(${unitMeta.shortLabel})`;
    if (heightUnitLabel) heightUnitLabel.textContent = `(${unitMeta.shortLabel})`;
    if (widthInput && !widthInput.value) widthInput.placeholder = unitMeta.widthPlaceholder;
    if (heightInput && !heightInput.value) heightInput.placeholder = unitMeta.heightPlaceholder;

    if (unitSwitch) {
      const canSwitchUnits = availableUnits.includes('feet') && availableUnits.includes('meter');
      unitSwitch.hidden = !canSwitchUnits;
      unitSwitch.setAttribute('aria-hidden', canSwitchUnits ? 'false' : 'true');
    }

    unitButtons.forEach(button => {
      const buttonUnit = normalizeCalculatorUnit(button.dataset.calcUnit || button.dataset.unit || button.textContent || 'feet');
      const isAvailable = availableUnits.includes(buttonUnit);
      button.disabled = !isAvailable;
      button.setAttribute('aria-pressed', buttonUnit === activeUnit ? 'true' : 'false');
    });

    return activeUnit;
  };

  const getCalculatorEstimate = (root, width, height, unit) => {
    const formulaConfig = readCalculatorFormulaConfig(root);
    const activeUnit = getActiveCalculatorUnit(root, formulaConfig || {}, unit);
    const unitMeta = getCalculatorUnitMeta(activeUnit);
    const activeFormula = formulaConfig[unitMeta.field];

    if (activeFormula) {
      const formulaResult = evaluateCalculatorFormula(activeFormula, width, height);

      if (Number.isFinite(formulaResult) && formulaResult > 0) {
        return {
          value: formulaResult,
          source: 'formula',
          label: formulaConfig.name || root.dataset.productTitle || '',
          formula: activeFormula,
          unit: activeUnit,
          areaLabel: unitMeta.areaLabel
        };
      }

      return {
        value: null,
        source: 'formula',
        label: formulaConfig.name || root.dataset.productTitle || '',
        formula: activeFormula,
        unit: activeUnit,
        areaLabel: unitMeta.areaLabel,
        error: 'The product formula could not be calculated. Please check the formula metaobject.'
      };
    }

    if (formulaConfig.hasFormulaMetafield) {
      return {
        value: null,
        source: 'formula',
        label: formulaConfig.name || root.dataset.productTitle || '',
        formula: '',
        unit: activeUnit,
        areaLabel: unitMeta.areaLabel,
        error: `The product formula metaobject is connected, but the ${unitMeta.field} formula field is empty. Check the metaobject field key/value for formula_${unitMeta.field}.`
      };
    }

    return {
      value: null,
      source: 'formula',
      label: '',
      formula: '',
      unit: activeUnit,
      areaLabel: unitMeta.areaLabel,
      error: 'This product does not have a panel calculator formula.'
    };
  };

  const initServiceDrawers = root => {
    const drawers = Array.from(root.querySelectorAll('[data-service-drawer]'));
    const detailButtons = Array.from(root.querySelectorAll('[data-service-details]'));
    const checkboxes = Array.from(root.querySelectorAll('[data-service-checkbox]'));
    const primaryButtons = Array.from(root.querySelectorAll('[data-service-popup-add]'));

    if (!drawers.length && !detailButtons.length) return;

    const serviceOwnerId = root.dataset.wdPdpServiceOwner || `wd-pdp-service-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    root.dataset.wdPdpServiceOwner = serviceOwnerId;

    /*
     * Taxi keeps pages in its own cloned cache and this drawer is portalled to
     * <body> so it can stay fixed to the viewport. When a shopper navigates to
     * another product and then uses Back, old portalled drawers with the same
     * IDs can remain in <body>. The Details button can then open the stale
     * drawer, whose Add button is still wired to a removed product form. Remove
     * every previously portalled service drawer before mounting this product's
     * fresh drawers.
     */
    if (drawers.length) {
      document.querySelectorAll('body > [data-service-drawer][data-wd-pdp-viewport-modal], body > [data-service-drawer][data-wd-pdp-portal]').forEach(drawer => {
        if (!drawers.includes(drawer)) drawer.remove();
      });
    }

    drawers.forEach(drawer => {
      drawer.dataset.wdPdpOwner = serviceOwnerId;
      drawer.dataset.wdPdpPortal = 'true';
      mountFixedModalToViewport(drawer, root);
    });

    let lastTrigger = null;
    let activeDrawer = null;
    let touchStartY = 0;

    const clearLegacyPageLock = () => {
      // The old service-details drawer locked <html>/<body>. On Shopify mobile
      // preview that can leave the page translated upward with a blank gap at
      // the bottom. This rebuilt drawer never locks the document; it only opens
      // a fixed overlay and lets the drawer panel handle its own scrolling.
      document.documentElement.classList.remove('wd-pdp-service-drawer-open');
      document.body.classList.remove('wd-pdp-service-drawer-open');
      document.documentElement.style.overflow = '';
      document.documentElement.style.overflowY = '';
      document.documentElement.style.position = '';
      document.documentElement.style.top = '';
      document.body.style.overflow = '';
      document.body.style.overflowY = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.paddingRight = '';
    };

    const getDrawerById = id => {
      if (!id) return null;

      try {
        const escapedId = CSS.escape(id);
        return root.querySelector(`#${escapedId}`)
          || document.querySelector(`[data-service-drawer][data-wd-pdp-owner="${serviceOwnerId}"]#${escapedId}`)
          || null;
      } catch (error) {
        return Array.from(document.querySelectorAll('[data-service-drawer]')).find(drawer => {
          return drawer.id === id && drawer.dataset.wdPdpOwner === serviceOwnerId;
        }) || null;
      }
    };

    const getCheckboxByVariantId = variantId => {
      if (!variantId) return null;
      return checkboxes.find(input => input.dataset.serviceVariantId === String(variantId));
    };

    const syncPrimaryButtons = () => {
      checkboxes.forEach(checkbox => {
        checkbox.closest('[data-service-card]')?.classList.toggle('is-selected', checkbox.checked);
      });

      primaryButtons.forEach(button => {
        const checkbox = getCheckboxByVariantId(button.dataset.serviceVariantId);
        const isAdded = Boolean(checkbox?.checked);
        button.classList.toggle('is-added', isAdded);
        button.textContent = isAdded
          ? (button.dataset.labelAdded || 'Added')
          : (button.dataset.labelAdd || button.textContent || 'Add service');
      });
    };

    const closeDrawers = options => {
      const shouldRestoreFocus = !(options && options.restoreFocus === false);
      const triggerToFocus = lastTrigger;

      drawers.forEach(drawer => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        window.setTimeout(() => {
          if (!drawer.classList.contains('is-open')) drawer.hidden = true;
        }, 360);
      });

      detailButtons.forEach(button => button.setAttribute('aria-expanded', 'false'));
      activeDrawer = null;
      lastTrigger = null;
      clearLegacyPageLock();

      if (shouldRestoreFocus && triggerToFocus && typeof triggerToFocus.focus === 'function') {
        window.setTimeout(() => triggerToFocus.focus({ preventScroll: true }), 40);
      }
    };

    const openDrawer = (drawer, trigger) => {
      if (!drawer) return;

      clearLegacyPageLock();
      lastTrigger = trigger || null;
      activeDrawer = drawer;

      drawers.forEach(other => {
        const isTarget = other === drawer;
        other.classList.toggle('is-open', false);
        other.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
        other.hidden = !isTarget;
      });

      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');

      const panel = drawer.querySelector('.wd-pdp__service-drawer-panel');
      if (panel) panel.scrollTop = 0;

      detailButtons.forEach(button => {
        button.setAttribute('aria-expanded', button.dataset.serviceDrawerTarget === drawer.id ? 'true' : 'false');
      });

      syncPrimaryButtons();
      window.requestAnimationFrame(() => drawer.classList.add('is-open'));

      const closeButton = drawer.querySelector('.wd-pdp__service-drawer-close');
      window.setTimeout(() => closeButton?.focus({ preventScroll: true }), 80);
    };

    const getPanelFromEvent = event => {
      const target = event.target;
      return target instanceof Element ? target.closest('.wd-pdp__service-drawer-panel') : null;
    };

    const panelIsAtBoundary = (panel, deltaY) => {
      if (!panel) return true;
      const atTop = panel.scrollTop <= 0;
      const atBottom = Math.ceil(panel.scrollTop + panel.clientHeight) >= panel.scrollHeight;
      return (deltaY < 0 && atTop) || (deltaY > 0 && atBottom);
    };

    detailButtons.forEach(button => {
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        const drawer = getDrawerById(button.dataset.serviceDrawerTarget);
        openDrawer(drawer, button);
      });
    });

    drawers.forEach(drawer => {
      drawer.querySelectorAll('[data-service-drawer-close]').forEach(button => {
        button.addEventListener('click', event => {
          event.preventDefault();
          closeDrawers();
        });
      });

      drawer.addEventListener('wheel', event => {
        if (drawer.hidden || !drawer.classList.contains('is-open')) return;
        const panel = getPanelFromEvent(event);
        if (!panel || panelIsAtBoundary(panel, event.deltaY || 0)) event.preventDefault();
      }, { passive: false });

      drawer.addEventListener('touchstart', event => {
        if (drawer.hidden || !drawer.classList.contains('is-open') || !event.touches.length) return;
        touchStartY = event.touches[0].clientY;
      }, { passive: true });

      drawer.addEventListener('touchmove', event => {
        if (drawer.hidden || !drawer.classList.contains('is-open') || !event.touches.length) return;
        const panel = getPanelFromEvent(event);
        const currentY = event.touches[0].clientY;
        const deltaY = touchStartY - currentY;

        if (!panel || panelIsAtBoundary(panel, deltaY)) event.preventDefault();
        touchStartY = currentY;
      }, { passive: false });
    });

    primaryButtons.forEach(button => {
      button.addEventListener('click', event => {
        event.preventDefault();
        const checkbox = getCheckboxByVariantId(button.dataset.serviceVariantId);
        if (checkbox && !checkbox.disabled) {
          checkbox.checked = true;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
        syncPrimaryButtons();
        closeDrawers();
      });
    });

    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', syncPrimaryButtons);
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && drawers.some(drawer => drawer.classList.contains('is-open') && !drawer.hidden)) {
        closeDrawers();
      }
    });

    window.addEventListener('pageshow', () => {
      if (!drawers.some(drawer => drawer.classList.contains('is-open') && !drawer.hidden)) clearLegacyPageLock();
    });

    clearLegacyPageLock();
    syncPrimaryButtons();
  };

  const initCalculator = root => {
    const calculatorOwnerId = root.dataset.wdPdpCalculatorOwner || `wd-pdp-calculator-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    root.dataset.wdPdpCalculatorOwner = calculatorOwnerId;

    document.querySelectorAll('body > [data-calculator-modal][data-wd-pdp-viewport-modal="true"]').forEach(existingModal => {
      const belongsToThisRoot = existingModal.__wdPdpRoot === root || existingModal.dataset.wdPdpOwner === calculatorOwnerId;
      if (!belongsToThisRoot) existingModal.remove();
    });

    const sourceModal = root.__wdPdpCalculatorModal && document.documentElement.contains(root.__wdPdpCalculatorModal)
      ? root.__wdPdpCalculatorModal
      : root.querySelector('[data-calculator-modal]');
    const modal = mountFixedModalToViewport(sourceModal, root);

    if (modal) {
      modal.dataset.wdPdpOwner = calculatorOwnerId;
      modal.__wdPdpRoot = root;
      root.__wdPdpCalculatorModal = modal;
      modal.setAttribute('aria-hidden', modal.hidden ? 'true' : 'false');
    }

    const open = root.querySelector('[data-calculator-open]');
    const closeButtons = modal ? modal.querySelectorAll('[data-calculator-close]') : root.querySelectorAll('[data-calculator-close]');
    const widthInput = (modal && modal.querySelector('[data-calc-width]')) || root.querySelector('[data-calc-width]');
    const heightInput = (modal && modal.querySelector('[data-calc-height]')) || root.querySelector('[data-calc-height]');
    const submit = (modal && modal.querySelector('[data-calc-submit]')) || root.querySelector('[data-calc-submit]');
    const result = (modal && modal.querySelector('[data-calc-result]')) || root.querySelector('[data-calc-result]');
    const apply = (modal && modal.querySelector('[data-calc-apply]')) || root.querySelector('[data-calc-apply]');
    const unitButtons = Array.from((modal && modal.querySelectorAll('[data-calc-unit]')) || root.querySelectorAll('[data-calc-unit]'));
    const qtyInput = root.querySelector('[data-quantity-input]');

    let calculatedQuantity = 0;

    [widthInput, heightInput].forEach(input => {
      if (!input) return;
      input.setAttribute('inputmode', 'decimal');
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('autocorrect', 'off');
      input.setAttribute('spellcheck', 'false');
    });

    updateCalculatorUnitUI(root, readCalculatorFormulaConfig(root));

    const getCalculatorRestoreScrollTop = () => {
      const openTop = Number(modal?.__wdPdpCalculatorOpenScrollTop);
      return Number.isFinite(openTop) ? openTop : getPageScrollTop();
    };

    const show = () => {
      if (!modal) return;
      syncVisualViewportHeight();
      modal.__wdPdpCalculatorOpenScrollTop = getPageScrollTop();
      modal.__wdPdpCalculatorClosing = false;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      modal.removeAttribute('data-wd-pdp-closing');
      modal.removeAttribute('data-wd-pdp-keyboard-active');
      modal.style.removeProperty('display');
      modal.style.removeProperty('pointer-events');
      lockCalculatorModal(modal.__wdPdpCalculatorOpenScrollTop);
      requestPdpLayoutRefresh('calculator-open');

      // Do not force-open the iOS keyboard. Auto-focus during the Safari visual
      // viewport resize is what can create the persistent bottom gap after Apply.
      if (!shouldUseMobileModalGuard()) {
        setTimeout(() => {
          try { widthInput?.focus({ preventScroll: true }); } catch (error) { widthInput?.focus(); }
        }, 40);
      }
    };

    const hide = (options = {}) => {
      if (!modal || modal.__wdPdpCalculatorClosing) return;

      const savedScrollTop = Math.max(0, Number(options.restoreScrollTop) || getCalculatorRestoreScrollTop());
      const activeElement = document.activeElement;
      const hadCalculatorFocus = activeElement && modal.contains(activeElement);
      const useMobileCloseSequence = shouldUseMobileModalGuard();
      const keyboardSettleDelay = useMobileCloseSequence ? (hadCalculatorFocus ? 150 : 35) : 0;
      const fadeDuration = useMobileCloseSequence ? 210 : 170;

      modal.__wdPdpCalculatorClosing = true;
      modal.setAttribute('aria-hidden', 'true');
      modal.setAttribute('data-wd-pdp-closing', 'prepare');
      modal.style.pointerEvents = 'none';

      if (hadCalculatorFocus && typeof activeElement.blur === 'function') {
        activeElement.blur();
      }

      const finishHide = () => {
        modal.hidden = true;
        modal.removeAttribute('data-wd-pdp-closing');
        modal.removeAttribute('data-wd-pdp-keyboard-active');
        modal.style.removeProperty('pointer-events');
        modal.__wdPdpCalculatorClosing = false;

        if (options.returnFocus && open && !shouldUseMobileModalGuard()) {
          try { open.focus({ preventScroll: true }); } catch (error) { open.focus(); }
        }
      };

      const beginFadeAndUnlock = () => {
        // Stabilize the page while the calculator is still covering it, then
        // fade the overlay away. This prevents the tiny close-time snap caused
        // by viewport cleanup and scroll restoration becoming visible.
        unlockCalculatorModal(savedScrollTop, options.reason || 'calculator-close', options.scrollTarget || null);

        window.requestAnimationFrame(() => {
          modal.setAttribute('data-wd-pdp-closing', 'true');
          window.setTimeout(finishHide, fadeDuration);
        });
      };

      window.setTimeout(beginFadeAndUnlock, keyboardSettleDelay);
    };

    open?.addEventListener('click', show);
    closeButtons.forEach(button => button.addEventListener('click', () => hide({
      returnFocus: true,
      reason: 'calculator-close',
      restoreScrollTop: getCalculatorRestoreScrollTop()
    })));

    if (modal && !modal.__wdPdpCalculatorTouchGuard) {
      modal.__wdPdpCalculatorTouchGuard = true;
      modal.addEventListener('touchmove', event => {
        if (!shouldUseMobileModalGuard() || modal.hidden) return;

        const panel = modal.querySelector('.wd-pdp__modal-panel');
        if (!panel || !panel.contains(event.target)) {
          event.preventDefault();
        }
      }, { passive: false });

      modal.addEventListener('focusin', event => {
        if (!shouldUseMobileModalGuard() || modal.hidden || modal.__wdPdpCalculatorClosing) return;
        if (event.target !== widthInput && event.target !== heightInput) return;

        modal.setAttribute('data-wd-pdp-keyboard-active', 'true');
        repairIOSCalculatorFocusScroll(modal, getCalculatorRestoreScrollTop(), 'calculator-input-focus');
      });

      modal.addEventListener('focusout', event => {
        if (!shouldUseMobileModalGuard()) return;
        if (event.target !== widthInput && event.target !== heightInput) return;

        window.setTimeout(() => {
          if (modal.__wdPdpCalculatorClosing) return;
          if (modal.contains(document.activeElement)) return;
          modal.removeAttribute('data-wd-pdp-keyboard-active');
          repairIOSCalculatorFocusScroll(modal, getCalculatorRestoreScrollTop(), 'calculator-input-blur');
        }, 120);
      });
    }

    unitButtons.forEach(button => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        const nextUnit = normalizeCalculatorUnit(button.dataset.calcUnit || button.textContent || 'feet');
        const formulaConfig = readCalculatorFormulaConfig(root);
        const availableUnits = getAvailableCalculatorUnits(formulaConfig);
        if (!availableUnits.includes(nextUnit)) return;

        root.__wdPdpCalculatorUnit = nextUnit;
        root.dataset.calculatorUnit = nextUnit;
        calculatedQuantity = 0;
        resetCalculatorResult(root);
        updateCalculatorUnitUI(root, formulaConfig);
      });
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && modal && !modal.hidden) hide({ returnFocus: true, reason: 'calculator-escape' });
    });

    submit?.addEventListener('click', () => {
      const width = getNumber(widthInput?.value, 0);
      const height = getNumber(heightInput?.value, 0);
      const area = width * height;

      if (!area) {
        calculatedQuantity = 0;
        if (result) result.textContent = 'Enter both wall width and height to calculate your panels.';
        if (apply) apply.hidden = true;
        return;
      }

      const estimate = getCalculatorEstimate(root, width, height, root.__wdPdpCalculatorUnit || root.dataset.calculatorUnit);

      if (!estimate || !Number.isFinite(estimate.value) || estimate.value <= 0) {
        calculatedQuantity = 0;
        if (result) result.textContent = estimate?.error || 'We could not calculate the required panels from this formula.';
        if (apply) apply.hidden = true;
        return;
      }

      calculatedQuantity = Math.max(1, Math.ceil(estimate.value));
      if (result) {
        const areaLabel = estimate.areaLabel || getCalculatorUnitMeta(estimate.unit || root.__wdPdpCalculatorUnit || root.dataset.calculatorUnit).areaLabel;
        const itemLabel = getCalculatorItemLabel(estimate.label || root.dataset.calculatorFormulaName || root.dataset.productTitle, calculatedQuantity);
        result.textContent = `Estimated area: ${area.toFixed(1)} ${areaLabel}. Recommended quantity: ${calculatedQuantity} ${itemLabel}.`;
      }
      if (apply) apply.hidden = false;
    });

    apply?.addEventListener('click', () => {
      if (!calculatedQuantity || !qtyInput) return;

      const savedScrollTop = getCalculatorRestoreScrollTop();
      qtyInput.value = calculatedQuantity;
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      const applyScrollTarget = root.querySelector('[data-purchase]') || root.querySelector('[data-calculator-block]') || root;
      hide({
        returnFocus: false,
        reason: 'calculator-apply',
        restoreScrollTop: savedScrollTop,
        scrollTarget: applyScrollTarget
      });
    });
  };

  const PDP_RATING_STAR_PATH = 'm12 1.8 3.12 6.32 6.98 1.02-5.05 4.92 1.2 6.96L12 17.74 5.76 21.02l1.19-6.96L1.9 9.14l6.98-1.02L12 1.8Z';

  const clampRatingValue = value => {
    const number = Number.parseFloat(String(value || '').replace(',', '.'));
    if (!Number.isFinite(number)) return null;
    return Math.max(0, Math.min(5, number));
  };

  const getReviewRatingValue = reviews => {
    if (!reviews) return null;

    const dataSources = [
      reviews,
      reviews.querySelector('[data-average-rating]'),
      reviews.querySelector('[data-score]'),
      reviews.querySelector('[data-rating]'),
      reviews.querySelector('.jdgm-prev-badge'),
      reviews.querySelector('.jdgm-prev-badge__stars')
    ].filter(Boolean);

    for (const source of dataSources) {
      const value = source.getAttribute?.('data-average-rating') ||
        source.getAttribute?.('data-score') ||
        source.getAttribute?.('data-rating');
      const rating = clampRatingValue(value);
      if (rating !== null) return rating;
    }

    const text = (reviews.textContent || '').replace(/\s+/g, ' ');
    const decimalMatch = text.match(/(?:^|\D)([0-5][.,]\d{1,3})(?=\D|$)/);
    const decimalRating = clampRatingValue(decimalMatch?.[1]);
    if (decimalRating !== null) return decimalRating;

    const ariaSource = reviews.querySelector('[aria-label*="star" i], [title*="star" i]');
    const ariaText = ariaSource?.getAttribute('aria-label') || ariaSource?.getAttribute('title') || '';
    const ariaDecimalMatch = ariaText.match(/([0-5][.,]\d+)/);
    const ariaDecimalRating = clampRatingValue(ariaDecimalMatch?.[1]);
    if (ariaDecimalRating !== null) return ariaDecimalRating;

    const ariaMatch = ariaText.match(/(?:^|\D)([0-5])(?=\D|$)/);
    const ariaRating = clampRatingValue(ariaMatch?.[1]);
    if (ariaRating !== null) return ariaRating;

    return null;
  };

  const createRatingSvg = () => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('focusable', 'false');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', PDP_RATING_STAR_PATH);
    svg.appendChild(path);
    return svg;
  };

  const buildFractionalStars = rating => {
    const wrapper = document.createElement('span');
    wrapper.className = 'wd-pdp__fractional-stars';
    wrapper.setAttribute('aria-hidden', 'true');
    wrapper.dataset.rating = String(rating);

    for (let index = 0; index < 5; index += 1) {
      const fill = Math.max(0, Math.min(1, rating - index));
      const star = document.createElement('span');
      star.className = 'wd-pdp__fractional-star';
      star.style.setProperty('--wd-star-fill', fill.toFixed(3));
      star.appendChild(createRatingSvg());

      const fillLayer = document.createElement('span');
      fillLayer.className = 'wd-pdp__fractional-star-fill';
      fillLayer.appendChild(createRatingSvg());
      star.appendChild(fillLayer);

      wrapper.appendChild(star);
    }

    return wrapper;
  };

  const hydrateRatingStars = reviews => {
    if (!reviews) return;

    const rating = getReviewRatingValue(reviews);
    if (rating === null) return;

    const appContainer = reviews.querySelector('.wd-pdp__app-reviews:not(:empty)');
    const fallbackContainer = reviews.querySelector('[data-fallback-reviews]');
    const ratingContainer = appContainer || fallbackContainer || reviews;
    const originalStars = ratingContainer.querySelector('.jdgm-prev-badge__stars, .wd-pdp__stars, .jdgm-star');
    const insertParent = originalStars?.parentElement || ratingContainer;
    const existing = insertParent.querySelector(':scope > .wd-pdp__fractional-stars') || ratingContainer.querySelector('.wd-pdp__fractional-stars');

    if (existing && Number(existing.dataset.rating) === rating) {
      ratingContainer.classList.add('wd-pdp__rating-enhanced');
      return;
    }

    const fractionalStars = buildFractionalStars(rating);
    if (existing) {
      existing.replaceWith(fractionalStars);
    } else if (originalStars && originalStars.parentElement) {
      originalStars.parentElement.insertBefore(fractionalStars, originalStars);
    } else {
      insertParent.insertBefore(fractionalStars, insertParent.firstChild);
    }

    ratingContainer.classList.add('wd-pdp__rating-enhanced');
  };

  const initRatingStars = root => {
    const reviews = root?.querySelector?.('[data-woodarq-reviews-trigger]');
    if (!reviews) return;

    const run = () => hydrateRatingStars(reviews);
    run();
    window.setTimeout(run, 120);
    window.setTimeout(run, 600);
    window.setTimeout(run, 1400);

    if (reviews.__wdPdpRatingObserver) return;
    reviews.__wdPdpRatingObserver = new MutationObserver(() => run());
    reviews.__wdPdpRatingObserver.observe(reviews, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-average-rating', 'data-score', 'data-rating', 'aria-label', 'title']
    });
  };

  const initHero = root => {
    if (!root || root.__wdPdpHeroInitialized) return;
    root.__wdPdpHeroInitialized = true;
    root.dataset.initialized = 'true';

    const variantsScript = root.querySelector('[data-variant-json]');
    let variants = [];

    try {
      variants = JSON.parse(variantsScript?.textContent || '[]');
    } catch (error) {
      console.warn('Woodarq PDP hero: could not parse variant JSON', error);
    }

    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    const gallery = initGallery(root);
    initCalculator(root);
    initRatingStars(root);

    const optionButtons = Array.from(root.querySelectorAll('[data-option-button]'));
    const optionLabels = Array.from(root.querySelectorAll('[data-option-label]'));
    const variantInput = root.querySelector('[data-variant-id-input]');
    const quantityInput = root.querySelector('[data-quantity-input]');
    const quantityHidden = root.querySelector('[data-quantity-input-hidden]');
    const price = root.querySelector('[data-price]');
    const comparePrice = root.querySelector('[data-compare-price]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const addText = root.querySelector('[data-atc-text]');
    const stickyAtcBar = root.querySelector('[data-wd-pdp-sticky-atc]');
    const stickyAtcButton = stickyAtcBar?.querySelector('[data-wd-sticky-add-to-cart]');
    const stickyAtcText = stickyAtcBar?.querySelector('[data-wd-sticky-atc-text]');
    const stickyPrice = stickyAtcBar?.querySelector('[data-wd-sticky-price]');
    const stickyComparePrice = stickyAtcBar?.querySelector('[data-wd-sticky-compare-price]');
    const stickyRatingStars = stickyAtcBar?.querySelector('[data-wd-sticky-rating-stars]');
    const stickyRatingValue = stickyAtcBar?.querySelector('[data-wd-sticky-rating-value]');
    const stickyReviewCount = stickyAtcBar?.querySelector('[data-wd-sticky-review-count]');
    const eta = root.querySelector('[data-delivery-eta]');
    const deliveryStock = root.querySelector('[data-delivery-stock]');
    const paymentTerms = root.querySelector('.shopify-payment-terms');
    const sampleBoxesScript = root.querySelector('[data-sample-box-json]');
    const sampleBox = root.querySelector('[data-wd-sample-box]');
    const sampleMedia = sampleBox?.querySelector('[data-sample-media]');
    const sampleTitle = sampleBox?.querySelector('[data-sample-title]');
    const sampleComparePrice = sampleBox?.querySelector('[data-sample-compare-price]');
    const samplePrice = sampleBox?.querySelector('[data-sample-price]');
    const sampleForm = sampleBox?.querySelector('[data-sample-form]');
    const sampleVariantInput = sampleBox?.querySelector('[data-sample-variant-input]');
    const sampleButton = sampleBox?.querySelector('[data-sample-button]');
    const sampleButtonText = sampleBox?.querySelector('[data-sample-button-text]');
    let sampleBoxItems = [];

    try {
      const parsed = JSON.parse(sampleBoxesScript?.textContent || '[]');
      sampleBoxItems = Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.warn('Woodarq PDP hero: could not parse variant sample box JSON', error);
    }

    const sampleBoxesByVariant = new Map(
      sampleBoxItems
        .filter(item => item && item.variant_id && item.sample_variant_id)
        .map(item => [String(item.variant_id), item])
    );
    const hasVariantSampleBoxes = sampleBoxesByVariant.size > 0;

    const calculatorProductFallback = normalizeCalculatorFormulaConfig(
      readCalculatorJson(root, '[data-calculator-product-fallback-json]', {})
    );
    const calculatorVariantFormulaItems = readCalculatorJson(root, '[data-calculator-variant-formulas-json]', []);
    const calculatorVariantFormulasById = new Map(
      (Array.isArray(calculatorVariantFormulaItems) ? calculatorVariantFormulaItems : [])
        .filter(item => item && item.id)
        .map(item => [String(item.id), normalizeCalculatorFormulaConfig(item)])
    );

    const getCalculatorConfigForVariant = variant => {
      const variantConfig = variant?.id ? calculatorVariantFormulasById.get(String(variant.id)) : null;
      if (variantConfig?.hasFormulaMetafield) return variantConfig;
      if (calculatorProductFallback?.hasFormulaMetafield) return calculatorProductFallback;

      return {
        hasFormulaMetafield: false,
        has_formula_metafield: false,
        name: '',
        feet: '',
        meter: '',
        formula_source: 'none'
      };
    };

    const syncCalculatorFormula = variant => {
      writeCalculatorFormulaConfig(root, getCalculatorConfigForVariant(variant));
    };

    const setSampleButtonState = available => {
      if (sampleButton) {
        sampleButton.dataset.sampleAvailable = available ? 'true' : 'false';
        sampleButton.disabled = !available;
      }

      if (sampleButtonText) {
        sampleButtonText.textContent = available ? 'Add to cart' : 'Sold out';
      }
    };

    const restoreSampleButtonState = fallbackText => {
      const available = sampleButton?.dataset.sampleAvailable === 'true';

      if (sampleButtonText) {
        sampleButtonText.textContent = available ? (fallbackText || 'Add to cart') : 'Sold out';
      }

      if (sampleButton) {
        sampleButton.disabled = !available;
      }
    };

    const updateSampleBox = variant => {
      if (!sampleBox || !hasVariantSampleBoxes) return;

      const config = variant?.id ? sampleBoxesByVariant.get(String(variant.id)) : null;

      if (!config) {
        sampleBox.setAttribute('hidden', '');
        sampleBox.setAttribute('aria-hidden', 'true');
        if (sampleVariantInput) sampleVariantInput.value = '';
        if (sampleForm) sampleForm.dataset.sampleVariantId = '';
        sampleBox.dataset.sampleUrl = '';
        sampleBox.removeAttribute('role');
        sampleBox.removeAttribute('tabindex');
        if (sampleMedia) sampleMedia.innerHTML = '';
        if (sampleTitle) sampleTitle.textContent = '';
        if (sampleComparePrice) {
          sampleComparePrice.textContent = '';
          sampleComparePrice.hidden = true;
        }
        if (samplePrice) {
          samplePrice.textContent = '';
          samplePrice.classList.remove('is-sale');
        }
        setSampleButtonState(false);
        return;
      }

      sampleBox.removeAttribute('hidden');
      sampleBox.setAttribute('aria-hidden', 'false');

      if (sampleVariantInput) sampleVariantInput.value = config.sample_variant_id;
      if (sampleForm) sampleForm.dataset.sampleVariantId = config.sample_variant_id;

      sampleBox.dataset.sampleUrl = config.sample_url || '';
      if (config.sample_url) {
        sampleBox.setAttribute('role', 'link');
        sampleBox.setAttribute('tabindex', '0');
      } else {
        sampleBox.removeAttribute('role');
        sampleBox.removeAttribute('tabindex');
      }

      if (sampleTitle) sampleTitle.textContent = config.title || 'Sample box';

      if (sampleMedia) {
        sampleMedia.innerHTML = '';

        if (config.image?.src) {
          const image = document.createElement('img');
          image.className = 'wd-pdp__sample-box-image';
          image.src = config.image.src;
          image.alt = config.image.alt || config.title || 'Sample box';
          image.loading = 'lazy';
          sampleMedia.appendChild(image);
        }
      }

      const priceValue = Number(config.price || 0);
      const compareValue = Number(config.compare_at_price || 0);
      const isOnSale = compareValue > priceValue;

      if (sampleComparePrice) {
        sampleComparePrice.textContent = isOnSale ? formatMoney(compareValue, moneyFormat) : '';
        sampleComparePrice.hidden = !isOnSale;
      }

      if (samplePrice) {
        samplePrice.textContent = formatMoney(priceValue, moneyFormat);
        samplePrice.classList.toggle('is-sale', isOnSale);
      }

      setSampleButtonState(Boolean(config.available));
    };

    const selectedOptions = () => {
      const optionIndexes = new Set(optionButtons.map(button => Number(button.dataset.optionIndex || 0)));
      return Array.from(optionIndexes)
        .sort((a, b) => a - b)
        .map(index => {
          const active = root.querySelector(`[data-option-button][data-option-index="${index}"].is-active`);
          return active ? active.dataset.value : '';
        });
    };

    const getCurrentVariant = () => {
      if (!variants.length) return null;
      if (!optionButtons.length) return variants.find(variant => String(variant.id) === String(variantInput?.value)) || variants[0];
      return findVariantByOptions(variants, selectedOptions()) || null;
    };

    const getStickyHeaderOffset = () => {
      const header = document.querySelector(
        '.main-header, [data-woodarq-header], #shopify-section-header, sticky-header, header.header, .shopify-section-header-sticky'
      );
      if (!header || typeof header.getBoundingClientRect !== 'function') return 0;

      const styles = window.getComputedStyle ? window.getComputedStyle(header) : null;
      if (styles && (styles.display === 'none' || styles.visibility === 'hidden')) return 0;

      const rect = header.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top > 12) return 0;
      return Math.max(0, Math.min(rect.bottom, 160));
    };

    const getReviewCountText = () => {
      const reviews = root.querySelector('[data-woodarq-reviews-trigger]');
      const appText = reviews?.querySelector?.('.jdgm-prev-badge__text, [data-number-of-reviews], [data-review-count]');
      const countAttr = appText?.getAttribute?.('data-number-of-reviews') || appText?.getAttribute?.('data-review-count');
      const attrText = countAttr ? `${countAttr} reviews` : '';
      const text = attrText || appText?.textContent || stickyAtcBar?.dataset.stickyReviewCount || '';
      return String(text).replace(/\s+/g, ' ').trim();
    };

    const formatStickyRating = rating => {
      const normalized = Math.round(Number(rating || 0) * 100) / 100;
      return normalized.toFixed(2).replace(/\.0+$/, '').replace(/(\.\d*[1-9])0+$/, '$1');
    };

    const syncStickyRating = () => {
      if (!stickyAtcBar) return;

      const reviews = root.querySelector('[data-woodarq-reviews-trigger]');
      const rating = getReviewRatingValue(reviews) ?? clampRatingValue(stickyAtcBar.dataset.stickyRating);

      if (rating !== null) {
        if (stickyRatingStars) {
          stickyRatingStars.innerHTML = '';
          stickyRatingStars.appendChild(buildFractionalStars(rating));
        }
        if (stickyRatingValue) stickyRatingValue.textContent = formatStickyRating(rating);
        stickyAtcBar.querySelector('.wd-pdp__sticky-rating')?.setAttribute('aria-label', `Rated ${formatStickyRating(rating)} out of 5`);
      }

      const reviewCountText = getReviewCountText();
      if (stickyReviewCount && reviewCountText) stickyReviewCount.textContent = reviewCountText;
    };

    const mountStickyAtcToViewport = () => {
      if (!stickyAtcBar || stickyAtcBar.dataset.wdStickyMounted === 'true') return;
      if (!document.body || !root || !root.isConnected || !document.documentElement.contains(root) || !addButton) {
        stickyAtcBar.remove?.();
        return;
      }

      const computedStyles = window.getComputedStyle ? window.getComputedStyle(root) : null;
      ['--wd-pdp-bg', '--wd-pdp-dark', '--wd-pdp-muted', '--wd-pdp-accent'].forEach(property => {
        const value = root.style.getPropertyValue(property) || computedStyles?.getPropertyValue(property);
        if (value) stickyAtcBar.style.setProperty(property, value.trim());
      });

      stickyAtcBar.dataset.wdStickyMounted = 'true';
      stickyAtcBar.dataset.wdStickyOwner = root.id || root.dataset.sectionId || 'woodarq-pdp-hero';
      stickyAtcBar.hidden = false;
      stickyAtcBar.removeAttribute('hidden');
      stickyAtcBar.style.removeProperty('display');
      document.body.appendChild(stickyAtcBar);
    };

    const syncStickyButtonFromPrimary = () => {
      if (!stickyAtcButton || !addButton) return;
      stickyAtcButton.disabled = addButton.disabled;
      if (stickyAtcText && addText) stickyAtcText.textContent = (addText.textContent || '').trim() || stickyAtcText.textContent;
    };

    const syncStickyVariant = variant => {
      if (!stickyAtcBar) return;

      if (!variant) {
        if (stickyAtcButton) stickyAtcButton.disabled = true;
        if (stickyAtcText) stickyAtcText.textContent = 'Unavailable';
        return;
      }

      const isOnSale = Boolean(variant.compare_at_price && variant.compare_at_price > variant.price);

      if (stickyPrice) {
        stickyPrice.textContent = formatMoney(variant.price, moneyFormat);
        stickyPrice.classList.toggle('is-sale', isOnSale);
      }

      if (stickyComparePrice) {
        if (isOnSale) {
          stickyComparePrice.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          stickyComparePrice.classList.remove('is-hidden');
        } else {
          stickyComparePrice.textContent = '';
          stickyComparePrice.classList.add('is-hidden');
        }
      }

      if (stickyAtcText) stickyAtcText.textContent = variant.available ? (root.dataset.addLabel || 'ADD TO CART') : (root.dataset.soldOutLabel || 'SOLD OUT');
      if (stickyAtcButton) stickyAtcButton.disabled = !variant.available;
      syncStickyButtonFromPrimary();
    };

    let stickyAtcRaf = null;

    const renderStickyAtcVisibility = () => {
      stickyAtcRaf = null;
      if (!stickyAtcBar || !addButton || typeof addButton.getBoundingClientRect !== 'function') return;

      const rect = addButton.getBoundingClientRect();
      const topGuard = getStickyHeaderOffset() + 8;
      const buttonHasSize = rect.width > 0 && rect.height > 0;
      const shouldShow = buttonHasSize && rect.bottom <= topGuard;

      stickyAtcBar.classList.toggle('is-visible', shouldShow);
      stickyAtcBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    const requestStickyAtcVisibility = () => {
      if (!stickyAtcBar || stickyAtcRaf) return;
      stickyAtcRaf = window.requestAnimationFrame ? window.requestAnimationFrame(renderStickyAtcVisibility) : window.setTimeout(renderStickyAtcVisibility, 16);
    };

    const initStickyAtcBar = () => {
      if (!stickyAtcBar) return;

      mountStickyAtcToViewport();

      stickyAtcButton?.addEventListener('click', event => {
        event.preventDefault();
        if (!addButton || addButton.disabled) return;
        addButton.click();
      });

      syncStickyRating();
      syncStickyVariant(getCurrentVariant());
      syncStickyButtonFromPrimary();

      window.addEventListener('scroll', requestStickyAtcVisibility, { passive: true });
      window.addEventListener('resize', requestStickyAtcVisibility);
      window.addEventListener('orientationchange', requestStickyAtcVisibility);

      document.addEventListener('shopify:section:unload', event => {
        if (event.target && event.target.contains(root) && stickyAtcBar.parentNode) {
          stickyAtcBar.remove();
        }
      });

      if ('IntersectionObserver' in window && addButton) {
        const observer = new IntersectionObserver(() => requestStickyAtcVisibility(), {
          root: null,
          threshold: [0, 0.01, 1]
        });
        observer.observe(addButton);
      }

      if (window.MutationObserver && addButton) {
        const buttonObserver = new MutationObserver(() => syncStickyButtonFromPrimary());
        buttonObserver.observe(addButton, {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true,
          attributeFilter: ['disabled', 'class', 'aria-disabled']
        });
      }

      const reviews = root.querySelector('[data-woodarq-reviews-trigger]');
      if (window.MutationObserver && reviews && !reviews.__wdPdpStickyRatingObserver) {
        reviews.__wdPdpStickyRatingObserver = new MutationObserver(() => syncStickyRating());
        reviews.__wdPdpStickyRatingObserver.observe(reviews, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['data-average-rating', 'data-score', 'data-rating', 'aria-label', 'title', 'data-number-of-reviews']
        });
      }

      requestStickyAtcVisibility();
      window.setTimeout(requestStickyAtcVisibility, 120);
      window.setTimeout(requestStickyAtcVisibility, 600);
      window.setTimeout(requestStickyAtcVisibility, 1200);
    };

    initStickyAtcBar();

    const updateEta = variant => {
      if (!eta || !variant) return;
      const cutoffHour = getNumber(root.dataset.cutoffHour, 16);
      const days = variant.available
        ? getNumber(root.dataset.businessDaysInStock, 5)
        : getNumber(root.dataset.businessDaysOutStock, 10);
      const arrival = addBusinessDays(new Date(), days);
      const date = arrival.toLocaleDateString(undefined, { month: 'long', day: 'numeric' });
      eta.textContent = `Estimated arrival: ${date}, Order within ${getOrderCutoffText(cutoffHour)}.`;
    };

    const updatePaymentTerms = variant => {
      if (!paymentTerms || !variant?.id) return;
      const params = new URLSearchParams(window.location.search);
      params.set('variant', variant.id);
      paymentTerms.setAttribute('data-variant-id', variant.id);
    };

    const updateVariantBridge = (optionsValue, variant, options = {}) => {
      const chosenOptions = Array.isArray(optionsValue) ? optionsValue : selectedOptions();
      const variantBridge = root.querySelector('[data-woodarq-variant-bridge]');
      const mediaGallery = root.querySelector('[data-woodarq-variant-wizard-gallery], media-gallery');
      const productFormId = root.dataset.productFormId || '';
      const escapedProductFormId = productFormId && window.CSS && typeof window.CSS.escape === 'function' ? window.CSS.escape(productFormId) : productFormId;
      const productForm = escapedProductFormId ? root.querySelector(`#${escapedProductFormId}`) || root.querySelector('form[action*="/cart/add"], form[action*="/cart/add.js"], form.wd-pdp__form') : root.querySelector('form[action*="/cart/add"], form[action*="/cart/add.js"], form.wd-pdp__form');

      root.querySelectorAll('[data-variant-bridge-select]').forEach(select => {
        const optionIndex = Number(select.dataset.optionIndex || 0);
        const nextValue = chosenOptions[optionIndex];
        if (typeof nextValue === 'undefined') return;

        if (select.value !== nextValue) {
          select.value = nextValue;
        }

        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });

      if (variantInput) {
        if (variant?.id) variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('input', { bubbles: true }));
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const detail = {
        variant,
        selectedOptions: chosenOptions,
        product: productData,
        sectionId: root.dataset.sectionId,
        productHandle: root.dataset.productHandle,
        source: options.source || 'woodarq-pdp-hero'
      };

      const eventNames = [
        'woodarq:pdp:variant-change',
        'variant:change',
        'variant:changed',
        'product:variant-change',
        'product:variant:change',
        'variantChange'
      ];
      const eventTargets = [root, variantBridge, mediaGallery, productForm, document, window].filter(Boolean);

      eventTargets.forEach(target => {
        eventNames.forEach(name => {
          target.dispatchEvent(new CustomEvent(name, { detail, bubbles: true }));
        });
      });

      if (variantBridge && options.dispatchNative !== false) {
        variantBridge.dispatchEvent(new Event('input', { bubbles: true }));
        variantBridge.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    const queueVariantWizardHydration = variant => {
      if (!variant) return;

      let lastRunAt = 0;
      const startedAt = Date.now();
      const mediaGallery = root.querySelector('[data-woodarq-variant-wizard-gallery], media-gallery');
      const sectionId = root.dataset.sectionId;

      const run = reason => {
        const currentVariant = getCurrentVariant() || variant;
        if (!currentVariant) return;

        lastRunAt = Date.now();
        updateVariantBridge(selectedOptions(), currentVariant, { source: `woodarq-pdp-hero:${reason}` });

        const featuredMediaId = currentVariant.featured_media?.id || currentVariant.featured_image?.id;
        if (featuredMediaId && mediaGallery && typeof mediaGallery.setActiveMedia === 'function' && sectionId) {
          try {
            mediaGallery.setActiveMedia(`${sectionId}-${featuredMediaId}`, false);
          } catch (error) {
            // Keep the custom Woodarq gallery as the source of truth if an app script throws here.
          }
        }

        window.requestAnimationFrame(() => {
          gallery.refreshAfterAppFiltering?.('auto');

          if (featuredMediaId) gallery.showMedia(featuredMediaId, 'auto');

          window.requestAnimationFrame(() => gallery.refreshAfterAppFiltering?.('auto'));
        });
      };

      const scheduleRun = (reason, delay = 60) => {
        window.setTimeout(() => run(reason), delay);
      };

      [0, 80, 180, 320, 550, 900, 1400, 2200, 3400, 5000, 7500, 10000, 14000, 18000, 22000].forEach(delay => {
        window.setTimeout(() => run(`delay-${delay}`), delay);
      });

      window.addEventListener('load', () => run('window-load'), { once: true });
      window.addEventListener('pageshow', () => run('pageshow'), { once: true });
      document.addEventListener('shopify:section:load', event => {
        if (!event.target || !event.target.contains(root)) return;
        run('section-load');
      });

      const hasVariantWizardGlobal = () => {
        try {
          return Object.keys(window).some(key => /productwiz|product_wiz|variantwizard|variant_wizard|variantimagewizard|variant_image_wizard|viw/i.test(key));
        } catch (error) {
          return false;
        }
      };

      const readinessPoll = window.setInterval(() => {
        if (Date.now() - startedAt > 30000) {
          window.clearInterval(readinessPoll);
          return;
        }

        if (hasVariantWizardGlobal() || Date.now() - lastRunAt > 2500) {
          run('readiness-poll');
        }
      }, 1200);

      if (window.MutationObserver) {
        const appReadyObserver = new MutationObserver(mutations => {
          const shouldReplay = mutations.some(mutation => {
            if (mutation.type === 'attributes') {
              const target = mutation.target;
              return Boolean(target && root.contains(target) && target.matches?.('[data-media-id], [data-target], media-gallery, variant-selects, .product__media-item, .thumbnail-list__item'));
            }

            return Array.from(mutation.addedNodes || []).some(node => {
              if (node.nodeType !== 1) return false;
              const value = `${node.id || ''} ${node.className || ''} ${node.getAttribute?.('src') || ''} ${node.getAttribute?.('href') || ''}`;
              return /productwiz|product_wiz|variantwizard|variant_wizard|variant-image|variant_image|viw/i.test(value) || node.querySelector?.('[class*="productwiz"], [id*="productwiz"], [class*="variant-wizard"], [id*="variant-wizard"], script[src*="productwiz"], script[src*="variant-image"]');
            });
          });

          if (shouldReplay) scheduleRun('app-mutation', 80);

          if (Date.now() - startedAt > 30000) appReadyObserver.disconnect();
        });

        appReadyObserver.observe(document.documentElement, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'data-media-id', 'data-target', 'data-variant-wizard-hidden', 'data-productwiz-hidden', 'data-pw-hidden']
        });
      }
    };

    const updateAvailabilityButtons = () => {
      if (!variants.length || !optionButtons.length) return;
      const current = selectedOptions();

      optionButtons.forEach(button => {
        const index = Number(button.dataset.optionIndex || 0);
        const candidate = [...current];
        candidate[index] = button.dataset.value;

        const exists = variants.some(variant => {
          return variant.options.every((option, optionIndex) => {
            return !candidate[optionIndex] || normalize(option) === normalize(candidate[optionIndex]);
          });
        });

        button.classList.toggle('is-disabled', !exists);
        button.disabled = !exists;
      });
    };

    const updateVariantState = variant => {
      syncCalculatorFormula(variant);

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        syncStickyVariant(null);
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (quantityHidden && quantityInput) quantityHidden.value = quantityInput.value;

      const isOnSale = Boolean(variant.compare_at_price && variant.compare_at_price > variant.price);

      if (price) {
        const saleLabel = isOnSale ? ` ${root.dataset.saleLabel || '(Sale)'}` : '';
        price.textContent = `${formatMoney(variant.price, moneyFormat)}${saleLabel}`;
        price.classList.toggle('is-sale', isOnSale);
      }

      if (comparePrice) {
        if (isOnSale) {
          comparePrice.innerHTML = `${formatMoney(variant.compare_at_price, moneyFormat)} <span>${root.dataset.compareLabel || '(Regular)'}</span>`;
          comparePrice.classList.remove('is-hidden');
        } else {
          comparePrice.textContent = '';
          comparePrice.classList.add('is-hidden');
        }
      }

      if (addButton) addButton.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? (root.dataset.addLabel || 'ADD TO CART') : (root.dataset.soldOutLabel || 'SOLD OUT');
      syncStickyVariant(variant);

      if (deliveryStock) {
        if (variant.available) {
          deliveryStock.innerHTML = `<strong>In-stock</strong> - Ready to ship.<br>${root.dataset.shippingText || 'Free Ground shipping'}`;
        } else {
          deliveryStock.innerHTML = '<strong>Out of stock</strong> - This option is currently unavailable.';
        }
      }

      if (variant.featured_media && variant.featured_media.id) {
        gallery.showMedia(variant.featured_media.id);
      } else if (variant.featured_image && variant.featured_image.id) {
        gallery.showMedia(variant.featured_image.id);
      } else {
        gallery.refreshAfterAppFiltering?.('auto');
      }

      updateSampleBox(variant);
      updateEta(variant);
      updatePaymentTerms(variant);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      updateVariantBridge(selectedOptions(), variant);
    };

    optionButtons.forEach(button => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        const index = button.dataset.optionIndex;
        root.querySelectorAll(`[data-option-button][data-option-index="${index}"]`).forEach(other => {
          other.classList.toggle('is-active', other === button);
        });

        const label = root.querySelector(`[data-option-label="${index}"]`);
        if (label) label.textContent = button.dataset.value;

        updateAvailabilityButtons();
        updateVariantState(getCurrentVariant());
      });
    });

    const setQuantity = value => {
      const quantity = Math.max(1, Math.floor(getNumber(value, 1)));
      if (quantityInput) quantityInput.value = quantity;
      if (quantityHidden) quantityHidden.value = quantity;
    };

    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => setQuantity(getNumber(quantityInput?.value, 1) - 1));
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => setQuantity(getNumber(quantityInput?.value, 1) + 1));
    quantityInput?.addEventListener('change', () => setQuantity(quantityInput.value));
    quantityInput?.addEventListener('input', () => {
      if (quantityHidden) quantityHidden.value = quantityInput.value;
    });

    initServiceDrawers(root);

    const refreshCartCount = cart => {
      if (!cart || typeof cart.item_count === 'undefined') return;

      document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count, #mini-cart-item-count').forEach(node => {
        node.textContent = cart.item_count;
        if ('hidden' in node) node.hidden = false;
      });
    };

    const escapeCartHtml = value => String(value ?? '').replace(/[&<>'"]/g, character => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;'
    })[character]);

    const getCartRoute = path => {
      const rootPath = window.Shopify?.routes?.root || '/';
      return `${rootPath.replace(/\/$/, '')}${path}`;
    };

    const formatCartMoney = cents => {
      const moneyFormat = window.Shopify?.money_format || '${{amount}}';
      const placeholderRegex = /{{\s*(\w+)\s*}}/;
      const match = moneyFormat.match(placeholderRegex);
      const placeholder = match ? match[1] : 'amount';

      const formatWithDelimiters = (value, precision = 2, thousands = ',', decimal = '.') => {
        const number = Number(value || 0) / 100;
        const fixed = number.toFixed(precision);
        const parts = fixed.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        const fractional = parts[1] ? decimal + parts[1] : '';
        return dollars + fractional;
      };

      let value;
      switch (placeholder) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount':
        default:
          value = formatWithDelimiters(cents, 2);
          break;
      }

      return moneyFormat.replace(placeholderRegex, value);
    };

    const setMiniCartLoading = isLoading => {
      document.querySelectorAll('[data-cart] .loading-bg, .mini-cart .loading-bg').forEach(el => {
        el.classList.toggle('loading-bg_active', !!isLoading);
      });
    };

    const updateMiniCartPadding = () => {
      const miniCartContent = document.querySelector('[data-cart] .mini-cart-content');
      if (!miniCartContent) return;

      if (miniCartContent.scrollHeight >= window.innerHeight * 0.7) {
        miniCartContent.classList.add('scroll');
      } else {
        miniCartContent.classList.remove('scroll');
      }
    };

    const buildMiniCartFromCart = cart => {
      if (!cart) return false;

      const cartContainer = document.querySelector('[data-cart] .mini-cart-content');
      if (!cartContainer) {
        refreshCartCount(cart);
        return false;
      }

      if (Number(cart.item_count || 0) === 0) {
        cartContainer.innerHTML = '<p class="mini-cart-empty">Cart is empty.</p>';
      } else {
        cartContainer.innerHTML = cart.items.map((item, index) => {
          const imageHtml = item.image
            ? `<img src="${escapeCartHtml(item.image)}" alt="${escapeCartHtml(item.product_title || item.title || '')}" class="mini-cart-product-preview">`
            : '';
          const price = Number.isFinite(Number(item.final_price)) ? item.final_price : item.price;

          return `
            <div class="mini-cart-item -p6" data-item="${index + 1}">
              <div class="mini-cart-image">${imageHtml}</div>
              <div class="mini-cart-details">
                <p class="mini-cart-title">${escapeCartHtml(item.product_title || item.title || '')}</p>
              </div>
              <div class="mini-cart-price">${formatCartMoney(price)} x ${item.quantity}</div>
              <div class="mini-cart-quantity -p0" data-line="${index + 1}">
                <button class="btn -p0" type="button" data-type="minus">-</button>
                <span>${item.quantity}</span>
                <button class="btn -p0" type="button" data-type="plus">+</button>
              </div>
              <span class="mini-cart-remove" role="button" tabindex="0" data-line="${index + 1}">Remove</span>
            </div>
          `;
        }).join('');
      }

      const total = document.querySelector('#mini-cart-total');
      if (total) total.textContent = formatCartMoney(cart.total_price);

      refreshCartCount(cart);
      updateMiniCartPadding();
      wireMiniCartEvents();
      return true;
    };

    const refreshMiniCart = async () => {
      const cartResponse = await fetch(getCartRoute('/cart.js'), { headers: { 'Accept': 'application/json' } });
      if (!cartResponse.ok) throw new Error('Unable to refresh cart.');
      const cart = await cartResponse.json();
      buildMiniCartFromCart(cart);
      return cart;
    };

    const openMiniCartDrawer = () => {
      const miniCart = document.querySelector('.mini-cart');
      const backdrop = document.querySelector('.mini-cart-global-backdrop, .global-backdrop, #global-backdrop');
      const instance = window.miniCartInstance;

      if (instance && instance.cart && instance.cartActive === false && typeof instance.toggleCart === 'function') {
        try {
          instance.toggleCart();
        } catch (error) {
          // Manual fallback below.
        }
      }

      if (miniCart) {
        miniCart.classList.add('mini-cart_active');
      }

      if (backdrop) {
        backdrop.classList.add('mini-cart-global-backdrop_active', 'global-backdrop_active');
      }

      document.body.classList.add('lock-scroll');

      if (instance && typeof instance === 'object') {
        instance.cartActive = true;
        if (!instance.cart && miniCart) {
          instance.cart = miniCart;
        }
        if (!instance.backdrop && backdrop) {
          instance.backdrop = backdrop;
        }
      }
    };

    const changeMiniCartLine = async (line, quantity) => {
      setMiniCartLoading(true);

      try {
        const response = await fetch(getCartRoute('/cart/change.js'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ line, quantity })
        });
        const cart = await response.json();

        if (!response.ok || cart.status === 422) {
          throw new Error(cart?.description || cart?.message || 'Unable to update cart.');
        }

        buildMiniCartFromCart(cart);
        document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        return cart;
      } catch (error) {
        console.warn('Woodarq PDP hero: mini cart line update failed', error);
        return refreshMiniCart().catch(() => null);
      } finally {
        setMiniCartLoading(false);
      }
    };

    function wireMiniCartEvents() {
      document.querySelectorAll('[data-cart] .mini-cart-quantity[data-line]').forEach(container => {
        const line = parseInt(container.dataset.line, 10);
        const minusBtn = container.querySelector('[data-type="minus"]');
        const plusBtn = container.querySelector('[data-type="plus"]');
        const quantityEl = container.querySelector('span');

        if (minusBtn) {
          minusBtn.onclick = () => {
            const currentQty = parseInt(quantityEl?.textContent || '0', 10);
            if (Number.isFinite(currentQty) && currentQty > 1) changeMiniCartLine(line, currentQty - 1);
          };
        }

        if (plusBtn) {
          plusBtn.onclick = () => {
            const currentQty = parseInt(quantityEl?.textContent || '0', 10);
            if (Number.isFinite(currentQty)) changeMiniCartLine(line, currentQty + 1);
          };
        }
      });

      document.querySelectorAll('[data-cart] .mini-cart-remove[data-line]').forEach(button => {
        const line = parseInt(button.dataset.line, 10);
        const remove = () => changeMiniCartLine(line, 0);
        button.onclick = remove;
        button.onkeydown = event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            remove();
          }
        };
      });
    }

    if (!window.WoodarqRefreshMiniCart) {
      window.WoodarqRefreshMiniCart = refreshMiniCart;
      document.addEventListener('cart:refresh', () => {
        refreshMiniCart().catch(error => console.warn('Woodarq PDP hero: cart refresh failed', error));
      });
    }

    const addToCart = async () => {
      const variant = getCurrentVariant();
      if (!variant || !variant.available || !addButton) return;

      const quantity = Math.max(1, Math.floor(getNumber(quantityInput?.value, 1)));
      const selectedServices = Array.from(root.querySelectorAll('[data-service-checkbox]:checked'))
        .map(input => Number(input.dataset.serviceVariantId))
        .filter(Boolean);

      const originalText = addText?.textContent || 'ADD TO CART';
      addButton.disabled = true;
      if (addText) addText.textContent = 'ADDING...';

      const items = [
        {
          id: Number(variant.id),
          quantity
        },
        ...selectedServices.map(id => ({
          id,
          quantity,
          properties: {
            _woodarq_addon_for: root.dataset.productHandle || ''
          }
        }))
      ];

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data?.description || data?.message || 'Unable to add this item to cart.');
        }

        if (addText) addText.textContent = 'Added';

        try {
          const cart = await refreshMiniCart();
          document.dispatchEvent(new CustomEvent('woodarq:cart:add', { detail: { add: data, cart } }));
          document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart } }));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        } catch (cartError) {
          console.warn('Woodarq PDP hero: cart drawer refresh failed', cartError);
          document.dispatchEvent(new CustomEvent('woodarq:cart:add', { detail: data }));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }

        openMiniCartDrawer();

        setTimeout(() => {
          if (addText) addText.textContent = originalText;
          addButton.disabled = !getCurrentVariant()?.available;
        }, 1400);
      } catch (error) {
        console.error(error);
        if (addText) addText.textContent = error.message || 'ERROR';
        setTimeout(() => {
          if (addText) addText.textContent = originalText;
          addButton.disabled = !getCurrentVariant()?.available;
        }, 2200);
      }
    };

    addButton?.addEventListener('click', addToCart);

    if (sampleBox) {
      if (sampleBox.dataset.sampleUrl) {
        sampleBox.setAttribute('role', 'link');
        sampleBox.setAttribute('tabindex', '0');
      }

      const goToSampleProduct = event => {
        const target = event?.target;
        if (target?.closest?.('[data-sample-form], [data-sample-button], button, input, select, textarea, a')) return;

        const sampleUrl = sampleBox.dataset.sampleUrl;
        if (!sampleUrl) return;

        window.location.href = sampleUrl;
      };

      sampleBox.addEventListener('click', goToSampleProduct);
      sampleBox.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (event.target !== sampleBox) return;
        event.preventDefault();
        goToSampleProduct(event);
      });
    }

    root.querySelectorAll('.wd-pdp__sample-box-form').forEach(currentSampleForm => {
      currentSampleForm.addEventListener('submit', async event => {
        event.preventDefault();
        event.stopImmediatePropagation();

        const currentSampleButton = currentSampleForm.querySelector('button[type="submit"]');
        const currentSampleButtonText = currentSampleButton?.querySelector('span');
        const originalText = currentSampleButtonText?.textContent || currentSampleButton?.textContent || 'Add to cart';
        const selectedSampleVariant = currentSampleForm.querySelector('[name="id"]')?.value;

        if (!selectedSampleVariant || currentSampleButton?.dataset.sampleAvailable === 'false') {
          restoreSampleButtonState(originalText);
          return;
        }

        if (currentSampleButton) {
          currentSampleButton.disabled = true;
        }

        if (currentSampleButtonText) {
          currentSampleButtonText.textContent = 'Adding...';
        }

        try {
          const response = await fetch(getCartRoute('/cart/add.js'), {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: new FormData(currentSampleForm)
          });
          const data = await response.json().catch(() => null);

          if (!response.ok || data?.status === 422) {
            throw new Error(data?.description || data?.message || 'Unable to add sample box to cart.');
          }

          try {
            await refreshMiniCart();
            document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: data } }));
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
          } catch (cartError) {
            console.warn('Woodarq PDP hero: cart drawer refresh failed after sample box add', cartError);
            document.dispatchEvent(new CustomEvent('woodarq:cart:add', { detail: data }));
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }

          openMiniCartDrawer();

          if (currentSampleButtonText) {
            currentSampleButtonText.textContent = 'Added';
          }

          window.setTimeout(() => {
            restoreSampleButtonState(originalText);
          }, 1400);
        } catch (error) {
          console.error(error);

          if (currentSampleButtonText) {
            currentSampleButtonText.textContent = 'Error';
          }

          window.setTimeout(() => {
            restoreSampleButtonState(originalText);
          }, 1800);
        }
      }, true);
    });

    updateAvailabilityButtons();
    const initialVariant = getCurrentVariant();
    updateVariantState(initialVariant);
    queueVariantWizardHydration(initialVariant);
  };

  const initAll = scope => {
    const context = scope || document;
    const roots = Array.from(context.querySelectorAll(ROOT_SELECTOR));
    const hasActivePdpHero = Boolean(document.querySelector(ROOT_SELECTOR));

    document.body?.classList.toggle('template-product-pdp-v2', hasActivePdpHero);

    if (!hasActivePdpHero) {
      document.querySelectorAll('body > [data-service-drawer][data-wd-pdp-viewport-modal], body > [data-service-drawer][data-wd-pdp-portal]').forEach(drawer => drawer.remove());
      document.querySelectorAll('body > [data-wd-pdp-sticky-atc], body > .wd-pdp__sticky-atc').forEach(bar => bar.remove());
      document.querySelectorAll('body > .wd-pdp__fractional-stars').forEach(stars => stars.remove());
    } else {
      document.querySelectorAll('body > [data-wd-pdp-sticky-atc]').forEach(bar => {
        const owner = bar.dataset.wdStickyOwner;
        const ownerRoot = owner ? document.getElementById(owner) : null;
        if (!ownerRoot && !document.querySelector(ROOT_SELECTOR)) bar.remove();
      });
    }

    roots.forEach(initHero);
  };

  window.WoodarqPdpHero.initAll = initAll;
  window.WoodarqPdpHero.initHero = initHero;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  window.addEventListener('shopify:section:load', event => {
    event.target?.querySelectorAll?.(ROOT_SELECTOR).forEach(root => {
      root.__wdPdpHeroInitialized = false;
      root.dataset.initialized = 'false';
      initHero(root);
    });
  });

  document.addEventListener('woodarq:pdp-v2:reinit', event => {
    initAll(event?.detail?.scope || document);
  });

  const observer = new MutationObserver(() => initAll(document));
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  /**
   * Delivery Information
   *
   * This is intentionally event-delegated instead of binding directly to the
   * Change Address button on first load. Shopify themes can re-render sections,
   * and the first patch could miss the click binding if the section was replaced
   * after the initial boot. Delegation keeps the button, modal close controls,
   * Apply button, Enter key, Escape key, and Theme Editor reloads working.
   */
  /*
   * v3: keep this separate from the older delivery-info guard so a browser that
   * still has a cached earlier copy can still receive the corrected delegated
   * click handler below.
   */
  if (window.__woodarqDeliveryInfoDelegatedV3) return;
  window.__woodarqDeliveryInfoDelegatedV3 = true;

  var ROOT_SELECTOR = '.delivery-info, [data-delivery-info], .wd-pdp__delivery-card';
  var TRIGGER_SELECTOR = '[data-delivery-address-trigger], #change-address-trigger, [id^="change-address-trigger"], .wd-pdp__delivery-link, a[href].wd-pdp__delivery-link';
  var MODAL_SELECTOR = '[data-delivery-zip-modal], #zip-modal, [id^="zip-modal"]';
  var INPUT_SELECTOR = '[data-delivery-zip-input], #zip-input, [id^="zip-input"]';
  var SUBMIT_SELECTOR = '[data-delivery-zip-submit], #zip-submit, [id^="zip-submit"]';
  var CLOSE_SELECTOR = '[data-delivery-zip-close], #zip-cancel, #zip-cancel-secondary, [id^="zip-cancel"], .delivery-info__modal-overlay';
  var ERROR_SELECTOR = '[data-delivery-zip-error], #zip-error, [id^="zip-error"]';
  var CITY_SELECTOR = '[data-delivery-city], #delivery-city, [id^="delivery-city"]';
  var LOADING_SELECTOR = '[data-delivery-zip-loading], #zip-loading, [id^="zip-loading"]';
  var STORAGE_KEY = 'woodarq_delivery_city';

  function mountDeliveryModalToViewport(root) {
    var modal = root && (root.__wdPdpDeliveryModal || root.querySelector(MODAL_SELECTOR));
    if (!modal || !document.body) return modal || null;

    if (!modal.__wdPdpOriginalParent) {
      modal.__wdPdpOriginalParent = modal.parentNode;
      modal.__wdPdpOriginalNextSibling = modal.nextSibling;
    }

    modal.__wdPdpDeliveryRoot = root;
    root.__wdPdpDeliveryModal = modal;
    modal.setAttribute('data-wd-pdp-viewport-modal', 'true');

    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    return modal;
  }

  function qs(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function qsa(root, selector) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(selector)) : [];
  }

  function closest(node, selector) {
    if (!node || node === document || node === window) return null;
    return node.closest ? node.closest(selector) : null;
  }

  function getRoot(node) {
    var root = closest(node, ROOT_SELECTOR);
    if (root) return root;

    var modal = closest(node, MODAL_SELECTOR);
    return modal && modal.__wdPdpDeliveryRoot ? modal.__wdPdpDeliveryRoot : null;
  }

  function getModal(root) {
    if (!root) return null;

    var portalledModal = root.__wdPdpDeliveryModal;
    if (portalledModal && document.documentElement.contains(portalledModal)) {
      return portalledModal;
    }

    return qs(root, MODAL_SELECTOR);
  }

  function qsInModalOrRoot(root, selector) {
    var modal = getModal(root);
    return qs(modal, selector) || qs(root, selector);
  }

  function getInput(root) {
    return qsInModalOrRoot(root, INPUT_SELECTOR);
  }

  function getSubmit(root) {
    return qsInModalOrRoot(root, SUBMIT_SELECTOR);
  }

  function getError(root) {
    return qsInModalOrRoot(root, ERROR_SELECTOR);
  }

  function getCity(root) {
    return qs(root, CITY_SELECTOR);
  }

  function getLoading(root) {
    return qsInModalOrRoot(root, LOADING_SELECTOR);
  }

  function hasOpenPdpModal() {
    return qsa(document, MODAL_SELECTOR + ', [data-calculator-modal]').some(function(modal) {
      return modal && !modal.hidden && modal.getAttribute('aria-hidden') !== 'true' && modal.style.display !== 'none';
    });
  }

  function lockPageForModal() {
    document.body.classList.add('wd-pdp-modal-open');
  }

  function unlockPageFromModal(force) {
    if (!force && hasOpenPdpModal()) return;

    document.documentElement.classList.remove('wd-pdp-modal-open');
    document.body.classList.remove('wd-pdp-modal-open');

    /*
      The delivery/address modal is moved to <body> so it can be fixed to the
      viewport. On some desktop viewport states Shopify/Chrome can leave the
      page in the locked modal state after the modal is hidden, which makes the
      PDP feel frozen until refresh. Clear every lock-related inline style here
      instead of relying only on class removal.
    */
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.documentElement.style.pointerEvents = '';
    document.body.style.pointerEvents = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
  }


  function forceDeliveryModalClosed(root) {
    var modal = getModal(root);
    if (!modal) return;

    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    modal.style.display = 'none';
    modal.style.pointerEvents = 'none';
  }

  function fetchWithTimeout(url, options, timeoutMs) {
    options = options || {};
    timeoutMs = timeoutMs || 5000;

    if (typeof AbortController === 'undefined') {
      return fetch(url, options);
    }

    var controller = new AbortController();
    var timer = setTimeout(function () {
      controller.abort();
    }, timeoutMs);

    var finalOptions = {};
    for (var k in options) {
      if (Object.prototype.hasOwnProperty.call(options, k)) {
        finalOptions[k] = options[k];
      }
    }
    finalOptions.signal = controller.signal;

    return fetch(url, finalOptions).then(
      function (res) {
        clearTimeout(timer);
        return res;
      },
      function (err) {
        clearTimeout(timer);
        throw err;
      }
    );
  }

  function setError(root, message) {
    var errorEl = getError(root);
    if (!errorEl) return;
    errorEl.textContent = message || '';
    errorEl.hidden = !message;
  }

  function setLoading(root, isLoading) {
    root.__woodarqDeliveryLoading = !!isLoading;

    var spinner = getLoading(root);
    var submit = getSubmit(root);
    var input = getInput(root);

    if (spinner) spinner.hidden = !isLoading;
    if (submit) submit.disabled = !!isLoading;
    if (input) input.disabled = !!isLoading;
  }

  function openModal(root) {
    if (!root) return;

    var modal = mountDeliveryModalToViewport(root);
    var input = getInput(root);

    if (!modal) return;

    modal.hidden = false;
    modal.style.display = '';
    modal.style.pointerEvents = '';
    modal.removeAttribute('aria-hidden');
    lockPageForModal();
    setError(root, '');

    if (input) {
      input.value = '';
      window.requestAnimationFrame(function () {
        window.setTimeout(function () {
          input.focus();
        }, 60);
      });
    }
  }

  function closeModal(root, forceUnlock) {
    if (!root) return;

    var input = getInput(root);

    forceDeliveryModalClosed(root);
    setError(root, '');
    setLoading(root, false);
    if (input) input.value = '';

    // Closing the address modal should always restore the page, even if a
    // hidden modal/drawer node elsewhere in the PDP still matches the modal selectors.
    unlockPageFromModal(true);

    window.requestAnimationFrame(function () {
      unlockPageFromModal(true);
    });

    window.setTimeout(function() {
      unlockPageFromModal(true);
    }, 0);

    window.setTimeout(function() {
      unlockPageFromModal(true);
    }, 120);
  }


  function setCity(root, city) {
    var cityEl = getCity(root);
    if (!cityEl || !city) return;
    cityEl.textContent = city;

    try {
      window.localStorage.setItem(STORAGE_KEY, city);
    } catch (e) {}
  }

  function getSavedCity() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function normaliseZip(zip) {
    return String(zip || '').trim().replace(/\s+/g, '');
  }

  async function fetchCityByZip(zip) {
    var cleanZip = normaliseZip(zip);

    if (!/^\d{5}(-\d{4})?$/.test(cleanZip)) {
      throw new Error('Please enter a valid 5-digit ZIP code.');
    }

    var response = await fetchWithTimeout(
      'https://api.zippopotam.us/us/' + encodeURIComponent(cleanZip),
      { method: 'GET' },
      6000
    );

    if (!response.ok) {
      throw new Error('Invalid ZIP code. Please check and try again.');
    }

    var data = await response.json();

    if (!data || !data.places || !data.places.length) {
      throw new Error('No city found for this ZIP code.');
    }

    var place = data.places[0];
    var state = place['state abbreviation'] || '';
    return state ? place['place name'] + ', ' + state : place['place name'];
  }

  function submitZip(root) {
    if (!root || root.__woodarqDeliveryLoading) return;

    var input = getInput(root);
    if (!input) return;

    var zip = normaliseZip(input.value);
    if (!zip) {
      setError(root, 'Please enter a ZIP code.');
      return;
    }

    if (!/^\d{5}(-\d{4})?$/.test(zip)) {
      setError(root, 'Please enter a valid 5-digit ZIP code.');
      return;
    }

    /*
      Do not keep the modal/body scroll locked while waiting on the ZIP lookup API.
      On some PDP loads that external request can be delayed, which made the page feel frozen
      after submitting a new address. We now accept the ZIP immediately, close/unlock the modal,
      then enrich the label with the city/state in the background when the lookup returns.
    */
    setError(root, '');
    setLoading(root, true);
    setCity(root, 'ZIP ' + zip);
    closeModal(root, true);
    setLoading(root, false);
    window.setTimeout(function() { unlockPageFromModal(true); }, 50);

    fetchCityByZip(zip)
      .then(function(city) {
        if (city) setCity(root, city);
      })
      .catch(function(error) {
        if (window.console && typeof window.console.warn === 'function') {
          window.console.warn('[Woodarq PDP] ZIP lookup failed:', error);
        }
      });
  }

  async function loadCityFromIP(root) {
    if (!root || root.__woodarqDeliveryCityLoaded) return;
    root.__woodarqDeliveryCityLoaded = true;

    var savedCity = getSavedCity();
    if (savedCity) {
      setCity(root, savedCity);
      return;
    }

    var cityEl = getCity(root);
    if (!cityEl) return;

    try {
      var response = await fetchWithTimeout('https://ipapi.co/json/', { method: 'GET' }, 5000);
      if (!response.ok) throw new Error('IP API returned non-200');

      var data = await response.json();
      if (!data || !data.city) throw new Error('No city in response');

      var region = data.region_code || data.region || '';
      var cityDisplay = region ? data.city + ', ' + region : data.city;
      cityEl.textContent = cityDisplay;
    } catch (error) {
      var fallback = (root.getAttribute('data-default-city') || '').trim();
      if (fallback && !(cityEl.textContent || '').trim()) {
        cityEl.textContent = fallback;
      }

      try {
        console.warn('[WoodarqDeliveryInfo] IP geolocation failed:', error && error.message ? error.message : error);
      } catch (e) {}
    }
  }

  function initDeliveryInfo(scope) {
    qsa(scope || document, ROOT_SELECTOR).forEach(function (root) {
      mountDeliveryModalToViewport(root);
      forceDeliveryModalClosed(root);
      loadCityFromIP(root);
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = closest(event.target, TRIGGER_SELECTOR);
    if (trigger) {
      var triggerRoot = getRoot(trigger);
      if (triggerRoot) {
        /*
         * This must run before the browser follows an <a href=""> fallback.
         * Some earlier Woodarq-inspired markup rendered Change Address as
         * an anchor, which makes Shopify point it back to the current product URL.
         */
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        openModal(triggerRoot);
        return false;
      }
    }

    var closeControl = closest(event.target, CLOSE_SELECTOR);
    if (closeControl) {
      var closeRoot = getRoot(closeControl);
      if (closeRoot) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        closeModal(closeRoot);
        return false;
      }
    }

    var submitButton = closest(event.target, SUBMIT_SELECTOR);
    if (submitButton) {
      var submitRoot = getRoot(submitButton);
      if (submitRoot) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        submitZip(submitRoot);
        return false;
      }
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      qsa(document, ROOT_SELECTOR).forEach(function (root) {
        var modal = getModal(root);
        if (modal && !modal.hidden) closeModal(root);
      });
      return;
    }

    if (event.key === 'Enter') {
      var input = closest(event.target, INPUT_SELECTOR);
      if (!input) return;

      var root = getRoot(input);
      if (!root) return;

      event.preventDefault();
      submitZip(root);
    }
  });

  function normaliseAddressTriggers(scope) {
    qsa(scope || document, TRIGGER_SELECTOR).forEach(function (trigger) {
      trigger.setAttribute('data-delivery-address-trigger', '');

      if (trigger.tagName && trigger.tagName.toLowerCase() === 'a') {
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('href', 'javascript:void(0)');
      }
    });
  }

  function boot() {
    normaliseAddressTriggers(document);
    initDeliveryInfo(document);

    qsa(document, MODAL_SELECTOR).forEach(function(modal) {
      if (modal.hidden || modal.getAttribute('aria-hidden') === 'true') {
        modal.style.display = 'none';
        modal.style.pointerEvents = 'none';
      }
    });

    unlockPageFromModal(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('pageshow', boot);
  document.addEventListener('shopify:section:load', function (event) {
    normaliseAddressTriggers(event.target || document);
    initDeliveryInfo(event.target || document);
  });

  try {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.slice.call(mutation.addedNodes || []).forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (
            (node.matches && (node.matches(ROOT_SELECTOR) || node.matches(TRIGGER_SELECTOR))) ||
            (node.querySelector && (node.querySelector(ROOT_SELECTOR) || node.querySelector(TRIGGER_SELECTOR)))
          ) {
            normaliseAddressTriggers(node);
            initDeliveryInfo(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();

(function () {
  var REVIEW_ROOT_SELECTOR = '.wd-pdp__reviews, [data-woodarq-reviews-trigger]';
  var REVIEW_TARGET_SELECTORS = [
    '[data-woodarq-customer-reviews]',
    '.woodarq-customer-reviews',
    '#reviews',
    '#sliderReviewProduct',
    '#judgeme_product_reviews',
    '.jdgm-widget.jdgm-review-widget',
    '.jdgm-rev-widg'
  ];

  if (window.__woodarqPdpHeroReviewScrollV4Bound) return;
  window.__woodarqPdpHeroReviewScrollV4Bound = true;

  var lastActivationTime = 0;
  var pointerStart = null;
  var touchStart = null;
  var activeTween = 0;

  function closest(el, selector) {
    while (el && el !== document && el.nodeType === 1) {
      if (el.matches && el.matches(selector)) return el;
      el = el.parentNode;
    }
    return null;
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function isVisibleElement(el) {
    if (!el || !document.documentElement.contains(el)) return false;
    if (el.hidden || el.getAttribute('aria-hidden') === 'true') return false;

    if (window.getComputedStyle) {
      var styles = window.getComputedStyle(el);
      if (styles.display === 'none' || styles.visibility === 'hidden') return false;
    }

    return true;
  }

  function getActiveTaxiView() {
    try {
      if (window.WoodarqPdpV2Stability && typeof window.WoodarqPdpV2Stability.getActiveScope === 'function') {
        var activeScope = window.WoodarqPdpV2Stability.getActiveScope();
        if (activeScope && activeScope.nodeType === 1 && activeScope.matches && activeScope.matches('[data-taxi-view]')) return activeScope;
      }
    } catch (error) {}

    var views = toArray(document.querySelectorAll('[data-taxi-view]'));
    if (!views.length) return null;

    var visibleViews = views.filter(isVisibleElement);
    return visibleViews[visibleViews.length - 1] || views[views.length - 1] || null;
  }

  function queryInScope(scope, selector) {
    if (!scope || !selector || !scope.querySelector) return null;
    return scope.querySelector(selector);
  }

  function getReviewsTarget() {
    var activeView = getActiveTaxiView();
    var scopes = [];

    if (activeView) scopes.push(activeView);
    scopes.push(document);

    for (var s = 0; s < scopes.length; s += 1) {
      var scope = scopes[s];
      for (var i = 0; i < REVIEW_TARGET_SELECTORS.length; i += 1) {
        var target = queryInScope(scope, REVIEW_TARGET_SELECTORS[i]);
        if (target && isVisibleElement(target)) return target;
      }
    }

    return null;
  }

  function getHeaderOffset() {
    var candidates = [
      document.querySelector('.main-header'),
      document.querySelector('.shopify-section-header'),
      document.querySelector('[data-header]'),
      document.querySelector('header')
    ];

    for (var i = 0; i < candidates.length; i += 1) {
      var header = candidates[i];
      if (!header || !isVisibleElement(header)) continue;

      var rect = header.getBoundingClientRect();
      var styles = window.getComputedStyle ? window.getComputedStyle(header) : null;
      var position = styles ? styles.position : '';

      if (rect.height > 0 && (position === 'fixed' || position === 'sticky' || rect.top <= 1)) {
        return Math.min(Math.ceil(rect.height + 18), 170);
      }
    }

    return 24;
  }

  function refreshScrollBounds() {
    try {
      if (typeof nt !== 'undefined' && nt) {
        if (nt.scroll && typeof nt.scroll.setScrollBounds === 'function') nt.scroll.setScrollBounds();
        if (nt.raf && typeof nt.raf.clamp === 'function') nt.raf.clamp();
      }
    } catch (error) {}
  }

  function canScrollElement(el) {
    if (!el || el === window || el === document || el.nodeType !== 1) return false;
    return el.scrollHeight > el.clientHeight + 2;
  }

  function getElementOverflowY(el) {
    try {
      var styles = window.getComputedStyle ? window.getComputedStyle(el) : null;
      return styles ? styles.overflowY : '';
    } catch (error) {
      return '';
    }
  }

  function isScrollableByCSS(el) {
    return /(auto|scroll|overlay)/.test(getElementOverflowY(el));
  }

  function getWindowScrollTop() {
    return window.pageYOffset ||
      (document.scrollingElement && document.scrollingElement.scrollTop) ||
      document.documentElement.scrollTop ||
      (document.body && document.body.scrollTop) ||
      0;
  }

  function getThemeSmoothScrollTop() {
    try {
      if (typeof nt !== 'undefined' && nt && nt.raf) {
        if (typeof nt.raf.smooth === 'function') return nt.raf.smooth();
        if (nt.raf.scroll && typeof nt.raf.scroll.rounded === 'number') return nt.raf.scroll.rounded;
      }
    } catch (error) {}

    return getWindowScrollTop();
  }

  function isThemeSmoothActive() {
    try {
      return !!(
        typeof nt !== 'undefined' &&
        nt &&
        nt.flags &&
        nt.flags.isSmooth &&
        nt.raf &&
        typeof nt.raf.scrollTo === 'function' &&
        window.innerWidth > 749
      );
    } catch (error) {
      return false;
    }
  }

  function getThemeDeviceScroller() {
    try {
      if (typeof nt !== 'undefined' && nt && nt.contentPage && nt.contentPage.parentNode) {
        return nt.contentPage.parentNode;
      }
    } catch (error) {}

    var activeView = getActiveTaxiView();
    return activeView && activeView.parentElement ? activeView.parentElement : null;
  }

  function getScrollableAncestor(node) {
    var el = node ? node.parentElement : null;

    while (el && el !== document.body && el !== document.documentElement) {
      if (isScrollableByCSS(el) && canScrollElement(el)) return el;
      el = el.parentElement;
    }

    return null;
  }

  function getNativeScroller(target) {
    var ancestorScroller = getScrollableAncestor(target);
    if (ancestorScroller && canScrollElement(ancestorScroller)) return ancestorScroller;

    /*
      On this theme mobile scrolling happens on <body> because <html> is fixed
      to var(--vh) and overflow hidden. Using window.scrollTo() there makes the
      PDP visibly snap and can leave the viewport translated upward. Prefer the
      real element scroller on mobile and animate its scrollTop ourselves.
    */
    if (window.innerWidth <= 749 && document.body && canScrollElement(document.body)) return document.body;

    var deviceScroller = getThemeDeviceScroller();
    if (window.innerWidth <= 749 && deviceScroller && isScrollableByCSS(deviceScroller) && canScrollElement(deviceScroller)) return deviceScroller;

    if (document.scrollingElement && canScrollElement(document.scrollingElement)) return document.scrollingElement;
    if (document.documentElement && canScrollElement(document.documentElement)) return document.documentElement;
    if (document.body && canScrollElement(document.body)) return document.body;

    return window;
  }

  function isRootElementScroller(scroller) {
    return scroller === document.body || scroller === document.documentElement || scroller === document.scrollingElement;
  }

  function getScrollTop(scroller) {
    if (!scroller || scroller === window) return getWindowScrollTop();
    return scroller.scrollTop || 0;
  }

  function calculateTopForScroller(target, scroller, offset) {
    if (scroller && scroller !== window) {
      var scrollerTop = isRootElementScroller(scroller) ? 0 : scroller.getBoundingClientRect().top;
      return Math.max(0, Math.round(target.getBoundingClientRect().top - scrollerTop + getScrollTop(scroller) - offset));
    }

    return Math.max(0, Math.round(target.getBoundingClientRect().top + getWindowScrollTop() - offset));
  }

  function setScrollTop(scroller, top) {
    if (scroller && scroller !== window) {
      scroller.scrollTop = top;
      return;
    }

    try { window.scrollTo(0, top); } catch (error) {}
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function tweenScroll(scroller, top, duration) {
    var token = ++activeTween;
    var start = getScrollTop(scroller);
    var distance = top - start;

    if (Math.abs(distance) < 2) {
      setScrollTop(scroller, top);
      return;
    }

    var startTime = (window.performance && performance.now) ? performance.now() : Date.now();
    var tweenDuration = Math.max(260, Math.min(duration || 620, 900));

    function step(now) {
      if (token !== activeTween) return;

      var time = now || Date.now();
      var progress = Math.min(1, (time - startTime) / tweenDuration);
      var next = start + (distance * easeOutCubic(progress));
      setScrollTop(scroller, next);

      if (progress < 1) window.requestAnimationFrame(step);
      else setScrollTop(scroller, top);
    }

    window.requestAnimationFrame(step);
  }

  function nativeScrollToTarget(target, offset) {
    var scroller = getNativeScroller(target);
    var top = calculateTopForScroller(target, scroller, offset);

    if (window.innerWidth <= 749) {
      tweenScroll(scroller, top, 620);
      return;
    }

    try {
      if (scroller && scroller !== window && typeof scroller.scrollTo === 'function') {
        scroller.scrollTo({ top: top, left: 0, behavior: 'smooth' });
      } else if (typeof window.scrollTo === 'function') {
        window.scrollTo({ top: top, left: 0, behavior: 'smooth' });
      } else {
        setScrollTop(scroller, top);
      }
    } catch (error) {
      setScrollTop(scroller, top);
    }
  }

  function scrollToReviews() {
    var target = getReviewsTarget();
    if (!target) return;

    refreshScrollBounds();

    window.requestAnimationFrame(function () {
      var offset = getHeaderOffset();

      if (isThemeSmoothActive()) {
        try {
          var smoothTop = Math.max(0, Math.round(target.getBoundingClientRect().top + getThemeSmoothScrollTop() - offset));
          nt.raf.scrollTo(smoothTop);
          return;
        } catch (error) {}
      }

      nativeScrollToTarget(target, offset);
    });
  }

  function isDuplicateActivation() {
    var now = Date.now ? Date.now() : new Date().getTime();
    if (now - lastActivationTime < 650) return true;
    lastActivationTime = now;
    return false;
  }

  function suppressEvent(event, preventDefault) {
    if (preventDefault !== false && event.cancelable !== false) event.preventDefault();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    event.stopPropagation();
  }

  function activateReviewScroll(event) {
    if (isDuplicateActivation()) {
      suppressEvent(event, true);
      return;
    }

    suppressEvent(event, true);
    scrollToReviews();
  }

  function onReviewTriggerPointerDown(event) {
    var reviewRoot = closest(event.target, REVIEW_ROOT_SELECTOR);
    if (!reviewRoot) return;

    pointerStart = {
      id: event.pointerId,
      x: event.clientX,
      y: event.clientY
    };
  }

  function onReviewTriggerPointerUp(event) {
    var reviewRoot = closest(event.target, REVIEW_ROOT_SELECTOR);
    if (!reviewRoot) return;

    if (!event.pointerType || event.pointerType === 'mouse') return;

    if (pointerStart && pointerStart.id === event.pointerId) {
      var dx = Math.abs((event.clientX || 0) - pointerStart.x);
      var dy = Math.abs((event.clientY || 0) - pointerStart.y);
      if (dx > 12 || dy > 12) return;
    }

    activateReviewScroll(event);
  }

  function getFirstTouch(event) {
    var touches = event.changedTouches && event.changedTouches.length ? event.changedTouches : event.touches;
    return touches && touches.length ? touches[0] : null;
  }

  function onReviewTriggerTouchStart(event) {
    var reviewRoot = closest(event.target, REVIEW_ROOT_SELECTOR);
    if (!reviewRoot) return;

    var touch = getFirstTouch(event);
    touchStart = touch ? { x: touch.clientX, y: touch.clientY } : null;

    // The compiled theme bundle also binds touchstart to .product-review.
    // Stop it here so mobile taps do not trigger that old instant scroll path.
    suppressEvent(event, false);
  }

  function onReviewTriggerTouchEnd(event) {
    var reviewRoot = closest(event.target, REVIEW_ROOT_SELECTOR);
    if (!reviewRoot) return;

    var touch = getFirstTouch(event);
    if (touchStart && touch) {
      var dx = Math.abs((touch.clientX || 0) - touchStart.x);
      var dy = Math.abs((touch.clientY || 0) - touchStart.y);
      if (dx > 12 || dy > 12) return;
    }

    activateReviewScroll(event);
  }

  function onReviewTriggerClick(event) {
    var reviewRoot = closest(event.target, REVIEW_ROOT_SELECTOR);
    if (!reviewRoot) return;

    activateReviewScroll(event);
  }

  function onReviewTriggerKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    var reviewRoot = closest(event.target, REVIEW_ROOT_SELECTOR);
    if (!reviewRoot) return;

    activateReviewScroll(event);
  }

  function addCapturedListener(type, handler, passive) {
    try {
      document.addEventListener(type, handler, { capture: true, passive: !!passive });
    } catch (error) {
      document.addEventListener(type, handler, true);
    }
  }

  addCapturedListener('pointerdown', onReviewTriggerPointerDown, true);
  addCapturedListener('pointerup', onReviewTriggerPointerUp, false);
  addCapturedListener('touchstart', onReviewTriggerTouchStart, false);
  addCapturedListener('touchend', onReviewTriggerTouchEnd, false);
  addCapturedListener('click', onReviewTriggerClick, false);
  document.addEventListener('keydown', onReviewTriggerKeydown, true);
})();
